export const SITE: Record<string, Record<string, string>> = {
  en: {
    menu: 'Menu', close: 'Close', signOut: 'Sign out', account: 'Account', noMatch: 'No symbol matches.',
    jump: 'Jump to a symbol', tradingAccounts: 'Trading Accounts',
    navProducts: 'Products', navEquities: 'Equities', navEquitiesSub: 'Shares on the morning list.',
    navIndexes: 'Indexes', navIndexesSub: 'SPY and QQQ.', navCrypto: 'Crypto', navCryptoSub: 'Bitcoin and ether.',
    navFx: 'FX', navFxSub: 'The euro dollar pair.', navMetals: 'Metals', navMetalsSub: 'Gold, quoted as XAUUSD.',
    navAi: 'AI', navAll: 'All markets', navAllSub: 'The full list.', navPractice: 'A practice order', navPracticeSub: 'Pick a name, then send the ticket.',
    navPlatform: 'Platform', navRead: 'AI read', navReadSub: 'The AI names a leader. You send the order.',
    navYours: 'Your account', navYoursIn: 'Name, email, and the practice balance.', navYoursOut: 'A funded practice account.',
    navAcc: 'Accounts', navOverview: 'Accounts overview', navOverviewSub: 'From $250 to $100,000.',
    navPortSub: 'Cash, positions, and orders.', navOpenSub: 'Balance starts at $0.', navSignSub: 'Return to the AI.',
    navFourSub: 'From sign-up to the first order.', navListSub: 'A short list, on purpose.', navSupportSub: 'Worldwide support from the AI.',
    navAiSub: 'What CapiTrade is built to do.', navClientsSub: 'What they say after a session.', navTelegram: 'Telegram.',
    navTheRead: 'The read', navTheReadSub: 'The AI watches. You send the order.', navHowStarts: 'How it starts', navHowStartsSub: 'Open the account, then pick a market.',
    footBlurb: 'AI-assisted trading tools for crypto and global markets.',
    footRisk: 'Risk warning. Trading cryptocurrencies and other financial instruments involves a high level of risk and you can lose some of your capital. Past performance, including results from automated or AI-based strategies, does not guarantee future results. Only trade with money you can afford to lose.',
    footRiskLink: 'Read the full risk disclosure.',
    footInfo: 'The content on this website is for general information only. It is not a recommendation, or an offer to buy or sell any asset. It does not take into account your personal objectives, financial situation or needs. Before trading, make sure the products offered match your goals and risk tolerance, and seek independent advice if needed.',
    footOperator: 'CapiTrade is operated by CapiTrade, registered in South Africa under number 2021/630672/05. Registered office: First Floor Kgabo Mashego, Eremomela Avenue, 1749, South Africa. CapiTrade provides software tools only. It does not provide investment advice and does not hold client funds. This website is not directed at residents of any jurisdiction where its use would be contrary to local law or regulation.',
    footRights: 'All rights reserved.',
    footTerms: 'Terms of service', footPrivacy: 'Privacy policy', footCookies: 'Cookie policy', footAml: 'AML policy', footRiskName: 'Risk disclosure',
    footHours: 'Mon to Fri, 9:00 to 18:00', footPolicies: 'Policies', docTitle: 'CapiTrade — AI trading',
    homeWelcome1: 'Unlock the world of', homeWelcome2: 'trading with', homeWelcome3: 'AI.',
    homeH1: 'Fully Automated Trading', homeH1em: 'Platform.',
    homeLede: 'Empowering AI trading agents with speed, security, and reliability.',
    homeTrade: 'Trade now', homeDeposit: 'First Deposit', homeLicensed: '® Licensed and Regulated',
    homeAltScreen: 'A dark AI trading screen with a gold chart on the monitor.',
    homeAltTrader: 'A trader smiling at a quote on her phone.',
    homeEdge: 'The crypto market never sleeps, and neither does your edge.',
    homeP1: 'Bitcoin and the rest of the market are moving right now. Every minute, new momentum builds, new leaders emerge, and new opportunities appear and vanish. Our AI trading bot scans the crypto markets around the clock, reading price action, volume, and momentum across dozens of assets, then names the strongest candidates so you don\'t have to chase them.',
    homeP2: 'You stay in control. The bot does the watching, the sorting, and the signaling. You make the call and send the order. It never trades on your behalf.',
    homeWhy: 'Why traders choose it',
    homeSpeed: 'Speed', homeSpeedBody: 'Signals update in real time, so you see the move while it still matters.',
    homeSecurity: 'Security', homeSecurityBody: 'Your decisions, your account, your funds. The bot never holds the keys.',
    homeReliable: 'Reliability', homeReliableBody: 'No fatigue, no distractions, no missed alerts. It works the market while you live your life.',
    homeRegister: 'The market won\'t slow down for anyone. Register today, and put an AI analyst on your side while the opportunity is still there.',
    homePlaying: 'Playing', homeFilm: 'AI film · 00:18', homeQuiet: 'a quieter trade', homeMorning: 'Morning market', homeLive: 'Live',
    homeOffline: 'The market is offline. Start the API on port 8080.', homeOpening: 'Opening the market…',
    homeTradeNvda: 'Trade NVIDIA',
    homeDepKicker: 'Make your first crypto deposit count', homeDepH: 'Make your first crypto deposit', homeDepEm: 'count.',
    homeDepP: 'Fund your account with crypto for the first time and receive a welcome bonus of up to 50% on your first deposit. Then let our AI trading bot go to work on the market for you.',
    homeHow: 'How it works',
    homeLi1: 'Register', homeLi1b: 'and open your account in minutes.',
    homeLi2: 'Deposit crypto', homeLi2b: '(BTC, ETH, USDT, and more) for the first time.',
    homeLi3: 'Receive your bonus', homeLi3b: 'and get access to your own AI trading bot.',
    homeLi4: 'Let the bot manage your account', homeLi4b: ', scanning the market around the clock and acting on opportunities, so you don\'t have to watch every move.',
    homeFine: 'Offer for new users only. Minimum deposit of 250$ applies. The bonus is subject to trading volume requirements. Trading crypto involves a high risk of loss. Our AI trading bot and portfolio management tools apply risk-management techniques, such as position sizing and stop-loss rules, to help you stay disciplined in volatile markets.',
    homeSupport: 'Worldwide Support', homeGlobal: 'Global Service', homeAssist: '24/7 Assistance', homeAccess: 'Worldwide Market Access', homeMulti: 'Multilingual Support',
    homeLiveRead: 'Live read', homeFocusA: 'Stay with the name you can explain.', homeFocusB: 'leads the live market at',
    homePaceA: 'markets are higher. You do not need all of them. Pick one and leave the rest in the market.',
    homePaceOf: 'of', homeNerveA: 'is the heavy print at', homeNerveB: 'Size the trade before you chase the feeling.',
    homeAnother: 'Another read', homeWait: 'The AI is waiting on the first print. Start the API, and the read will follow the market.',
    homeAsk: 'Ask the AI', homeReadPrices: 'Read of live prices.',
    homeM1: 'Register while the market is still bid.', homeM2: 'Let the AI name the leader.', homeM3: 'First Deposit is practice cash. Then send the order.',
    homeClients: 'Clients', homeReviews: 'What they say after the first session.', homeStars: '5 stars',
    homeR1t: 'Crypto', homeR1: 'I deposited, got my bonus, and had my bot running the same day. Setup took minutes, and it was easy to follow.',
    homeR2t: 'Equities', homeR2: 'I used to stare at charts all day. Now the bot watches the market around the clock, and I check in when it suits me.',
    homeR3t: 'Gold and bitcoin', homeR3: 'What I like is the discipline. The bot follows its risk rules even when I would have panicked.',
    homeMarkets: 'Markets', homeShort: 'A short list, on purpose.', homeAll: 'All markets',
    homeThMarket: 'Market', homeThSession: 'Session', homeThLast: 'Last', homeThChange: 'Change', homeEmpty: 'Waiting for the first print.',
    homeFourK: 'Get started in four steps', homeFourH: 'From sign-up to your first AI-powered trade in minutes.',
    homeS1: 'Open an account', homeS1b: 'Create your account. Enter your name, email, and a password. Verification takes just a few minutes.',
    homeS2: 'Pick a market', homeS2b: 'Make your first deposit. Fund your account with BTC, ETH, USDT, or other supported crypto (minimum $250) and claim your welcome bonus of up to 50%.',
    homeS3: 'Send a market order', homeS3b: 'Activate your AI trading bot. Choose your markets and risk settings, and your bot starts scanning the market around the clock.',
    homeS4: 'Check the account', homeS4b: 'Track everything live. Your balance, equity, and profit and loss update in real time. Adjust your settings or withdraw whenever you like, subject to the bonus terms.',
    homeNow: 'Register now', homePartners: 'Partnerships', homeCloseH: 'The stronger print will not wait for an', homeCloseEm: 'empty account.',
    homeCloseP: 'Open your account today, make your first crypto deposit of $250 or more, and receive a welcome bonus of up to 50%. Your AI trading bot gets to work right away.',
    mktKicker: 'Market', mktTitle: 'Markets', mktLede: 'Fifteen names. Search, filter, and open a ticket.',
    mktSearch: 'Search markets', mktPh: 'Symbol or name', mktClass: 'Asset class',
    mktMarket: 'Market', mktClassCol: 'Class', mktTrend: 'Trend', mktLast: 'Last', mktChange: 'Change', mktVolume: 'Volume',
    mktOffline: 'The AI is offline. Start the API, then refresh.', mktOpening: 'Opening the market…', mktNone: 'Nothing matches that search.',
    classALL: 'All', classEQUITY: 'Equities', classINDEX: 'Indexes', classCRYPTO: 'Crypto', classFX: 'FX', classCOMMODITY: 'Metals',
    oneEQUITY: 'Equity', oneINDEX: 'Index', oneCRYPTO: 'Crypto', oneFX: 'FX', oneCOMMODITY: 'Metal',
    accTitle: 'Accounts', accPort: 'Your portfolio', accOpen: 'Open an account', accRange: 'From $250 to $100,000.', accFrom: 'From',
    accClassic: 'Classic Account', accClassicLine: 'Simple access. A first look at the market, with support when you ask.',
    accSilver: 'Silver Account', accSilverLine: 'Wider market exposure, one trading bot, 24/7 support, and 1 account manager upon request.',
    accGold: 'Gold Account', accGoldLine: 'Broader market exposure, more trading bots, 24/7 support, and 2 account managers upon request.',
    accPlat: 'Platinum Account', accPlatLine: 'Deep market exposure, a stronger set of trading bots, priority 24/7 support, and 3 account managers.',
    accVip: 'VIP Account', accVipLine: 'Full access to a financial advisor and 1–5 account managers, with every trading bot and the widest market exposure.',
    inKicker: 'Your account', inH: 'The market does not wait.', inP: 'Return to crypto, shares, and gold. Speed, security, and a read that stayed on.',
    inSpeed: 'Speed', inSpeedB: 'See the move while it still matters.', inSec: 'Security', inSecB: 'Your account. Your decisions.',
    inRel: 'Reliability', inRelB: 'The AI does not clock out.', inTitle: 'Sign in', inEmail: 'Email', inEmailErr: 'Enter the email on your account.',
    inPass: 'Password', inPassErr: 'Enter your password.', inBusy: 'Signing in…', inNew: 'New here?', inCreate: 'Create an account', inFail: 'Could not sign in.',
    upKicker: 'Open an account', upH: 'Register while the market is open.', upP: 'An AI for crypto, shares, and gold. Speed, security, and a read that stays on.',
    upTitle: 'Sign up', upH2: 'Create your account', upName: 'Full name', upNameErr: 'Tell us what to call you.', upEmailErr: 'Enter a valid email.',
    upPhone: 'Phone', upCode: 'Country code', upCodeShort: 'Code', upCodePh: 'Country or code', upNoCountry: 'No country matches that.', upNumber: 'Number',
    upReal: 'Enter a real', upReal2: 'number.', upChooseCode: 'Choose the country code, then the number.', upCountry: 'Country', upSelect: 'Select a country', upCountryErr: 'Choose your country.',
    upPassErr: 'Use at least 8 characters.', upConfirm: 'Confirm password', upMismatch: 'Those passwords do not match.', upBusy: 'Creating…', upCreate: 'Create account',
    detKicker: 'Personal details', detH: 'We want to know you better', detP: 'A few details, then you can open Deposit.',
    detAddress: 'Address', detCity: 'City', detZip: 'Zip or postal code', detResidence: 'Country of residence',
    detNation: 'Nationality', detBirth: 'Date of birth', detBirthHint: 'DD.MM.YYYY', detBirthErr: 'Enter a real date as DD.MM.YYYY.',
    detEmpty: 'Fill in every field.', detProceed: 'Proceed', detBusy: 'Saving…',
    upAlready: 'Already registered?', upFail: 'Could not open the account.',
    trMissing: 'That market is not on the AI.', trMissingP: 'CapiTrade keeps a short list. Pick another name from the market.', trBack: 'Back to markets',
    trOpen: 'Open', trHigh: 'High', trLow: 'Low', trVolume: 'Volume', trSession: 'Session', trCandles: 'candles', trSide: 'Order side',
    trBuy: 'Buy', trSell: 'Sell', trQty: 'Quantity', trFill: 'Est. fill', trNotional: 'Notional', trCash: 'Cash', trSending: 'Sending…',
    trWatchOff: 'Remove from watchlist', trWatchOn: 'Add to watchlist', trSign: 'Sign in to trade', trNew: 'New to the AI?', trOpenAcc: 'Open account',
    trFine: 'Market order. Fills immediately at the touch, plus a 0.02% spread.', trOpening: 'Opening the market…',
    trWatchFail: 'Could not update the watchlist.', trOrderFail: 'The order was not filled.',
    trQtyZero: 'Enter a quantity greater than zero.',
    trFilled: 'Filled {side} {qty} {symbol} at {price}.',
    trTicket: 'Ticket',
    pfKicker: 'Profile', pfP: 'The details saved on this account.', pfDetails: 'Profile details', pfName: 'Name', pfEmail: 'Email', pfPhone: 'Phone',
    pfCountry: 'Country', pfCash: 'Cash', pfMissing: 'Not on file', pfBack: 'Back to the AI',
    poDeposit: 'Deposit', poMarkets: 'Markets', poBot: 'AI bot', poIq: 'InvestIQ', poGet: 'Get bot', poHelp: 'Help', poProfile: 'Profile',
    poEquity: 'Equity', poPnl: 'P&L', poWatch: 'Watchlist', poMovers: 'Top movers', poSell: 'Sell', poBuy: 'Buy', poEmpty: 'The watchlist is empty.',
    poChart: 'Opening the chart…', poSymbol: 'Symbol', poDay: 'Day', poLast: 'last', poPositions: 'Open positions', poFills: 'Recent fills',
    poNoPos: 'You don\'t have any open positions.', poNoPosB: 'Buy from the watchlist and the position shows up here.',
    poQty: 'Qty', poAvg: 'Avg', poNoFills: 'No fills yet.', poNoFillsB: 'A market order lands here as soon as it fills.',
    poSide: 'Side', poPrice: 'Price', poTime: 'Time', poOpeningAcc: 'Opening the account…', poLoadFail: 'Could not load the account.',
    poPay: 'Crypto payment', poConfirmed: 'Once your deposit is confirmed with us, we will verify your payment and add it to your balance. You will then receive your bonus and access to your account features.',
    poChoose: 'Choose your account type', poAccounts: 'Accounts', poMin: 'Minimum deposit', poNext: 'Next', poGreat: 'Great choice',
    poPeople: 'people chose', poStarted: 'and started trading.', poNetwork: 'Choose your network', poNetworks: 'Networks', poBack: 'Back',
    poCopied: 'Copied', poCopy: 'Copy address', poSendOnly: 'Send only', poOn: 'on the', poNetworkWord: 'network.',
    poAfter: 'After you send it, tell the AI on Telegram.', poLastPrice: 'Last price', poStats: 'Stats', poAnalysis: 'Analysis', poIndicators: 'Indicators',
    poTape: 'Read from the tape.', poBotAlt: 'An AI trading bot at a desk of market screens.', poBotTitle: 'AI trading bot',
    poBotP: 'The bot stays on the tape for you. It follows the trend, the RSI, and the moving averages, and it works the account while you are away from the screen.',
    poBotAccess: 'Deposit your account to get access to Bot.', poHelpTitle: 'Talk to the AI',
    poHelpP: 'Pick one question. The chat answers, then offers the next step. It will not tell you what to buy.',
    poExplain: 'Explain the AI', poReadM: 'Read a market', poOpenMine: 'Open my account',
    askTitle: 'AI assistant', askSub: 'One question at a time. Not investment advice.', askStart: 'Where should we start? I answer one step at a time, and I will not tell you what to buy.',
    askPh: 'Or type your own question', askSend: 'Send', askReplying: 'The AI is replying.', askOffline: 'I need the API on port 8080 before I can answer. Start it, then ask again.',
    lgHome: 'Home Page', lgPdf: 'Open the privacy policy (PDF)',
    lgTermsT: 'Terms of service',
    lgTerms1: 'These terms describe how the CapiTrade practice desk may be used. The full operating terms will be published here once the legal company name, country, and registration number are confirmed.',
    lgTerms2: 'The content on this website is for general information only. It is not investment advice, a recommendation, or an offer to buy or sell any asset. It does not take into account your personal objectives, financial situation or needs.',
    lgTerms3: 'CapiTrade is operated by CapiTrade, registered in South Africa under number 2021/630672/05.',
    lgPrivT: 'Privacy policy', lgPriv1: 'The privacy policy is the PDF linked below. It covers what CapiTrade collects, why, and the rights you have under POPIA.',
    lgCookT: 'Cookie policy', lgCook1: 'The site stores a sign-in token in the browser so the account stays open. It does not run a marketing cookie banner and it does not set advertising cookies. You can clear the token by signing out, or by clearing this site\'s data in your browser.',
    lgAmlT: 'AML policy', lgAml1: 'A confirmed deposit is checked before it is added to a balance. The full anti-money-laundering policy will be published here once the legal company name, country, and registration number are confirmed.',
    lgRiskT: 'Risk disclosure',
    lgRisk1: 'Trading cryptocurrencies and other financial instruments involves a high level of risk and you can lose some of your capital. Past performance, including results from automated or AI-based strategies, does not guarantee future results. Only trade with money you can afford to lose.',
    lgRisk2: 'The content on this website is for general information only. It is not a recommendation, or an offer to buy or sell any asset. It does not take into account your personal objectives, financial situation or needs. Before trading, make sure the products offered match your goals and risk tolerance, and seek independent advice if needed.',
    iqNoCandles: 'The tape does not have 14 candles yet, so RSI, MACD, and the averages cannot be calculated.',
    iqRsiLine: '{symbol} RSI (14) is {rsi}{shift}. {note}',
    iqShiftUp: ', up from {prior} three candles ago', iqShiftDown: ', down from {prior} three candles ago', iqShiftFlat: ', nearly unchanged from {prior} three candles ago',
    iqRsiHigh: 'A read above 70 means the last 14 candles gained much faster than they fell.',
    iqRsiLow: 'A read under 30 means the last 14 candles fell much faster than they rose.',
    iqRsiMid: 'That is the middle of the 0 to 100 scale, so recent gains and losses are close.',
    iqMacdLine: 'MACD is {line}, {side} its signal at {signal}, and {hist}.',
    iqAbove: 'above', iqBelow: 'below',
    iqHistPosWide: 'the histogram is positive and widening', iqHistPosNarrow: 'the histogram is positive and narrowing',
    iqHistNegWide: 'the histogram is negative and widening', iqHistNegNarrow: 'the histogram is negative and narrowing',
    iqHistPos: 'the histogram is positive', iqHistNeg: 'the histogram is negative', iqHistFlat: 'the histogram is flat',
    iqPrice20: 'Price is {side} the 20-period average at {price}.',
    iqPrice2050: 'Price is {a} the 20-period average at {p20} and {b} the 50-period average at {p50}.',
    iqBandUp: 'Price is outside the upper Bollinger band at {price}.',
    iqBandDown: 'Price is outside the lower Bollinger band at {price}.',
    iqBandIn: 'Price is inside the Bollinger bands, {low} to {high}.',
    iqStochTop: 'Stochastic %K is {value}, near the top of its 14-candle range.',
    iqStochBot: 'Stochastic %K is {value}, near the bottom of its 14-candle range.',
    iqStoch: 'Stochastic %K is {value}.',
    iqAtrLine: 'Average true range (14) is {range}.',
    iqSession: 'On the session, price is {above} above the low and {under} under the high, {pct}% through the range.',
    iqSelect: 'Select a symbol to read the session.',
    iqPlace: 'The last print is {pct}% of the way from the session low {low} to the session high {high}.',
    iqStretched: 'Stretched', iqWashed: 'Washed out', iqFirm: 'Firm', iqSoft: 'Soft', iqNeutral: 'Neutral',
    iqRsiName: 'RSI (14)', iqMacdName: 'MACD (12, 26)', iqSignalName: 'Signal (9)', iqHistName: 'Histogram',
    iqSma20Name: 'SMA 20', iqSma50Name: 'SMA 50', iqBollUpName: 'Bollinger upper', iqBollLoName: 'Bollinger lower',
    iqStochName: 'Stochastic %K', iqAtrName: 'ATR (14)',
    iqMacdNote: 'Fast average minus slow average', iqSignalNote: '9-period average of MACD',
    iqBollUpNote: '20-period average plus 2 deviations', iqBollLoNote: '20-period average minus 2 deviations',
    iqAtrNote: 'Average true range of the last 14 candles',
    iqNeeds15: 'Needs 15 closes', iqNeeds35: 'Needs 35 closes', iqNeeds14: 'Needs 14 candles',
    iqNeedsMore: 'Needs more candles for the {label}',
    iqAboveLabel: 'Price is above the {label}', iqBelowLabel: 'Price is below the {label}',
    iqRsiStretchNote: 'Stretched, above 70', iqRsiWashNote: 'Washed out, under 30', iqRsiMidNote: 'Middle of the scale',
    iqStochTopNote: 'Near the top of the range', iqStochBotNote: 'Near the bottom of the range', iqStochMidNote: 'Close versus the 14-candle high and low',
    iqAvg20: '20-period average', iqAvg50: '50-period average',
    trustOpening: 'Opening Trust Wallet on this page…',
    trustConnected: 'Trust Wallet is open. Your address on this page:',
    trustMissing: 'Trust Wallet is not installed in this browser. Add the Trust Wallet extension, then open it again from here. It stays on this deposit page.',
    trustClosed: 'Trust Wallet was closed.',
    trustRetry: 'Open Trust Wallet',
    trustDownload: 'Get Trust Wallet',
  },
  fr: {
    "menu": "Menu",
    "close": "Fermer",
    "signOut": "Se déconnecter",
    "account": "Compte",
    "noMatch": "Aucun symbole ne correspond.",
    "jump": "Aller à un symbole",
    "tradingAccounts": "Comptes de trading",
    "navProducts": "Produits",
    "navEquities": "Actions",
    "navEquitiesSub": "Les titres de la liste du matin.",
    "navIndexes": "Indices",
    "navIndexesSub": "SPY et QQQ.",
    "navCrypto": "Crypto",
    "navCryptoSub": "Bitcoin et ether.",
    "navFx": "Change",
    "navFxSub": "La paire euro-dollar.",
    "navMetals": "Métaux",
    "navMetalsSub": "L’or, coté XAUUSD.",
    "navAi": "IA",
    "navAll": "Tous les marchés",
    "navAllSub": "La liste complète.",
    "navPractice": "Un ordre d’entraînement",
    "navPracticeSub": "Choisissez un nom, puis envoyez le ticket.",
    "navPlatform": "Plateforme",
    "navRead": "Lecture IA",
    "navReadSub": "L’IA désigne un leader. Vous envoyez l’ordre.",
    "navYours": "Votre compte",
    "navYoursIn": "Nom, e-mail et solde d’entraînement.",
    "navYoursOut": "Un compte d’entraînement approvisionné.",
    "navAcc": "Comptes",
    "navOverview": "Aperçu des comptes",
    "navOverviewSub": "De 250 $ à 100 000 $.",
    "navPortSub": "Cash, positions et ordres.",
    "navOpenSub": "Le solde commence à 0 $.",
    "navSignSub": "Revenir à l’IA.",
    "navFourSub": "De l’inscription au premier ordre.",
    "navListSub": "Une liste courte, volontairement.",
    "navSupportSub": "Assistance mondiale depuis l’IA.",
    "navAiSub": "Ce pour quoi CapiTrade est fait.",
    "navClientsSub": "Ce qu’ils disent après une séance.",
    "navTelegram": "Telegram.",
    "navTheRead": "La lecture",
    "navTheReadSub": "L’IA observe. Vous envoyez l’ordre.",
    "navHowStarts": "Comment ça commence",
    "navHowStartsSub": "Ouvrez le compte, puis choisissez un marché.",
    "footBlurb": "Outils de trading assistés par IA pour la crypto et les marchés mondiaux.",
    "footRisk": "Avertissement sur les risques. Le trading de cryptomonnaies et d’autres instruments financiers comporte un niveau de risque élevé et vous pouvez perdre une partie de votre capital. Les performances passées, y compris les résultats de stratégies automatisées ou fondées sur l’IA, ne garantissent pas les résultats futurs. Ne tradez qu’avec de l’argent que vous pouvez vous permettre de perdre.",
    "footRiskLink": "Lire l’intégralité de l’avertissement sur les risques.",
    "footInfo": "Le contenu de ce site est fourni à titre d’information générale uniquement. Ce n’est pas une recommandation, ni une offre d’achat ou de vente d’un actif. Il ne tient pas compte de vos objectifs personnels, de votre situation financière ou de vos besoins. Avant de trader, assurez-vous que les produits proposés correspondent à vos objectifs et à votre tolérance au risque, et demandez un avis indépendant si besoin.",
    "footOperator": "CapiTrade est exploité par CapiTrade, enregistré en Afrique du Sud sous le numéro 2021/630672/05. Siège social : First Floor Kgabo Mashego, Eremomela Avenue, 1749, Afrique du Sud. CapiTrade fournit uniquement des outils logiciels. Il ne fournit pas de conseil en investissement et ne détient pas les fonds des clients. Ce site ne s’adresse pas aux résidents d’un pays où son utilisation serait contraire à la loi ou à la réglementation locale.",
    "footRights": "Tous droits réservés.",
    "footTerms": "Conditions d’utilisation",
    "footPrivacy": "Politique de confidentialité",
    "footCookies": "Politique de cookies",
    "footAml": "Politique LBC",
    "footRiskName": "Avertissement sur les risques",
    "footHours": "Du lundi au vendredi, de 9 h 00 à 18 h 00",
    "footPolicies": "Politiques",
    "docTitle": "CapiTrade — trading avec IA",
    "homeWelcome1": "Ouvrez le monde du",
    "homeWelcome2": "trading avec",
    "homeWelcome3": "l’IA.",
    "homeH1": "Plateforme de trading",
    "homeH1em": "entièrement automatisée.",
    "homeLede": "Des agents de trading IA, avec vitesse, sécurité et fiabilité.",
    "homeTrade": "Trader maintenant",
    "homeDeposit": "Premier dépôt",
    "homeLicensed": "® Agréé et réglementé",
    "homeAltScreen": "Un écran de trading IA sombre, avec un graphique doré sur le moniteur.",
    "homeAltTrader": "Une trader souriant devant un cours sur son téléphone.",
    "homeEdge": "Le marché crypto ne dort jamais, et votre avantage non plus.",
    "homeP1": "Bitcoin et le reste du marché bougent en ce moment. Chaque minute, un nouvel élan se forme, de nouveaux leaders apparaissent, et de nouvelles occasions surgissent puis disparaissent. Notre bot de trading IA scrute les marchés crypto en continu, lit le prix, le volume et l’élan sur des dizaines d’actifs, puis désigne les candidats les plus forts pour que vous n’ayez pas à les courir.",
    "homeP2": "Vous gardez la main. Le bot observe, trie et signale. Vous décidez et envoyez l’ordre. Il ne trade jamais à votre place.",
    "homeWhy": "Pourquoi les traders le choisissent",
    "homeSpeed": "Vitesse",
    "homeSpeedBody": "Les signaux se mettent à jour en temps réel, vous voyez donc le mouvement tant qu’il compte encore.",
    "homeSecurity": "Sécurité",
    "homeSecurityBody": "Vos décisions, votre compte, vos fonds. Le bot ne détient jamais les clés.",
    "homeReliable": "Fiabilité",
    "homeReliableBody": "Pas de fatigue, pas de distraction, pas d’alerte manquée. Il suit le marché pendant que vous vivez votre vie.",
    "homeRegister": "Le marché ne ralentit pour personne. Inscrivez-vous aujourd’hui et placez un analyste IA de votre côté tant que l’occasion est encore là.",
    "homePlaying": "Lecture",
    "homeFilm": "Film IA · 00:18",
    "homeQuiet": "un trade plus calme",
    "homeMorning": "Marché du matin",
    "homeLive": "En direct",
    "homeOffline": "Le marché est hors ligne. Démarrez l’API sur le port 8080.",
    "homeOpening": "Ouverture du marché…",
    "homeTradeNvda": "Trader NVIDIA",
    "homeDepKicker": "Faites compter votre premier dépôt crypto",
    "homeDepH": "Faites compter votre premier dépôt crypto",
    "homeDepEm": "pour de vrai.",
    "homeDepP": "Approvisionnez votre compte en crypto pour la première fois et recevez un bonus de bienvenue jusqu’à 50 % sur votre premier dépôt. Ensuite, laissez notre bot de trading IA travailler le marché pour vous.",
    "homeHow": "Comment ça marche",
    "homeLi1": "Inscrivez-vous",
    "homeLi1b": "et ouvrez votre compte en quelques minutes.",
    "homeLi2": "Déposez de la crypto",
    "homeLi2b": "(BTC, ETH, USDT et plus) pour la première fois.",
    "homeLi3": "Recevez votre bonus",
    "homeLi3b": "et accédez à votre propre bot de trading IA.",
    "homeLi4": "Laissez le bot gérer votre compte",
    "homeLi4b": ", en scrutant le marché en continu et en agissant sur les occasions, pour que vous n’ayez pas à suivre chaque mouvement.",
    "homeFine": "Offre réservée aux nouveaux utilisateurs. Un dépôt minimum de 250 $ s’applique. Le bonus est soumis à des conditions de volume de trading. Le trading de crypto comporte un risque élevé de perte. Notre bot de trading IA et nos outils de gestion de portefeuille appliquent des techniques de gestion du risque, comme le dimensionnement des positions et des règles de stop, pour vous aider à rester discipliné sur des marchés volatils.",
    "homeSupport": "Assistance mondiale",
    "homeGlobal": "Service mondial",
    "homeAssist": "Assistance 24 h/24 et 7 j/7",
    "homeAccess": "Accès aux marchés du monde entier",
    "homeMulti": "Assistance multilingue",
    "homeLiveRead": "Lecture en direct",
    "homeFocusA": "Restez sur le nom que vous pouvez expliquer.",
    "homeFocusB": "mène le marché en direct à",
    "homePaceA": "marchés sont en hausse. Vous n’avez pas besoin de tous. Choisissez-en un et laissez le reste au marché.",
    "homePaceOf": "sur",
    "homeNerveA": "est l’impression lourde à",
    "homeNerveB": "Dimensionnez l’ordre avant de courir après le ressenti.",
    "homeAnother": "Une autre lecture",
    "homeWait": "L’IA attend la première impression. Démarrez l’API, et la lecture suivra le marché.",
    "homeAsk": "Demander à l’IA",
    "homeReadPrices": "Lecture des prix en direct.",
    "homeM1": "Inscrivez-vous tant que le marché est encore demandé.",
    "homeM2": "Laissez l’IA désigner le leader.",
    "homeM3": "Le premier dépôt est du cash d’entraînement. Ensuite, envoyez l’ordre.",
    "homeClients": "Clients",
    "homeReviews": "Ce qu’ils disent après la première séance.",
    "homeStars": "5 étoiles",
    "homeR1t": "Crypto",
    "homeR1": "J’ai déposé, reçu mon bonus, et mon bot tournait le jour même. La mise en place a pris quelques minutes, et c’était simple à suivre.",
    "homeR2t": "Actions",
    "homeR2": "Avant, je restais devant les graphiques toute la journée. Maintenant le bot surveille le marché en continu, et je regarde quand ça me convient.",
    "homeR3t": "Or et bitcoin",
    "homeR3": "Ce que j’aime, c’est la discipline. Le bot suit ses règles de risque même quand j’aurais paniqué.",
    "homeMarkets": "Marchés",
    "homeShort": "Une liste courte, volontairement.",
    "homeAll": "Tous les marchés",
    "homeThMarket": "Marché",
    "homeThSession": "Séance",
    "homeThLast": "Dernier",
    "homeThChange": "Variation",
    "homeEmpty": "En attente de la première impression.",
    "homeFourK": "Commencez en quatre étapes",
    "homeFourH": "De l’inscription à votre premier trade assisté par IA, en quelques minutes.",
    "homeS1": "Ouvrir un compte",
    "homeS1b": "Créez votre compte. Entrez votre nom, votre e-mail et un mot de passe. La vérification ne prend que quelques minutes.",
    "homeS2": "Choisir un marché",
    "homeS2b": "Faites votre premier dépôt. Approvisionnez votre compte en BTC, ETH, USDT ou une autre crypto prise en charge (minimum 250 $) et réclamez votre bonus de bienvenue jusqu’à 50 %.",
    "homeS3": "Envoyer un ordre au marché",
    "homeS3b": "Activez votre bot de trading IA. Choisissez vos marchés et vos réglages de risque, et votre bot commence à scruter le marché en continu.",
    "homeS4": "Vérifier le compte",
    "homeS4b": "Suivez tout en direct. Votre solde, vos fonds propres et votre profit et perte se mettent à jour en temps réel. Ajustez vos réglages ou retirez quand vous voulez, sous réserve des conditions du bonus.",
    "homeNow": "Inscrivez-vous maintenant",
    "homePartners": "Partenariats",
    "homeCloseH": "La meilleure impression n’attendra pas",
    "homeCloseEm": "un compte vide.",
    "homeCloseP": "Ouvrez votre compte aujourd’hui, faites votre premier dépôt crypto de 250 $ ou plus, et recevez un bonus de bienvenue jusqu’à 50 %. Votre bot de trading IA se met au travail tout de suite.",
    "mktKicker": "Marché",
    "mktTitle": "Marchés",
    "mktLede": "Quinze noms. Cherchez, filtrez et ouvrez un ticket.",
    "mktSearch": "Chercher des marchés",
    "mktPh": "Symbole ou nom",
    "mktClass": "Classe d’actif",
    "mktMarket": "Marché",
    "mktClassCol": "Classe",
    "mktTrend": "Tendance",
    "mktLast": "Dernier",
    "mktChange": "Variation",
    "mktVolume": "Volume",
    "mktOffline": "L’IA est hors ligne. Démarrez l’API, puis actualisez.",
    "mktOpening": "Ouverture du marché…",
    "mktNone": "Rien ne correspond à cette recherche.",
    "classALL": "Tout",
    "classEQUITY": "Actions",
    "classINDEX": "Indices",
    "classCRYPTO": "Crypto",
    "classFX": "Change",
    "classCOMMODITY": "Métaux",
    "oneEQUITY": "Action",
    "oneINDEX": "Indice",
    "oneCRYPTO": "Crypto",
    "oneFX": "Change",
    "oneCOMMODITY": "Métal",
    "accTitle": "Comptes",
    "accPort": "Votre portefeuille",
    "accOpen": "Ouvrir un compte",
    "accRange": "De 250 $ à 100 000 $.",
    "accFrom": "À partir de",
    "accClassic": "Compte Classic",
    "accClassicLine": "Un accès simple. Un premier regard sur le marché, avec de l’aide quand vous la demandez.",
    "accSilver": "Compte Silver",
    "accSilverLine": "Une exposition plus large, un bot de trading, une assistance 24 h/24 et 7 j/7, et 1 chargé de compte sur demande.",
    "accGold": "Compte Gold",
    "accGoldLine": "Une exposition plus large encore, davantage de bots, une assistance 24 h/24 et 7 j/7, et 2 chargés de compte sur demande.",
    "accPlat": "Compte Platinum",
    "accPlatLine": "Une exposition profonde, un ensemble plus fort de bots, une assistance prioritaire 24 h/24 et 7 j/7, et 3 chargés de compte.",
    "accVip": "Compte VIP",
    "accVipLine": "Accès complet à un conseiller financier et à 1 à 5 chargés de compte, avec tous les bots et l’exposition la plus large.",
    "inKicker": "Votre compte",
    "inH": "Le marché n’attend pas.",
    "inP": "Revenez à la crypto, aux actions et à l’or. Vitesse, sécurité, et une lecture qui est restée allumée.",
    "inSpeed": "Vitesse",
    "inSpeedB": "Voyez le mouvement tant qu’il compte encore.",
    "inSec": "Sécurité",
    "inSecB": "Votre compte. Vos décisions.",
    "inRel": "Fiabilité",
    "inRelB": "L’IA ne pointe pas.",
    "inTitle": "Connexion",
    "inEmail": "E-mail",
    "inEmailErr": "Entrez l’e-mail de votre compte.",
    "inPass": "Mot de passe",
    "inPassErr": "Entrez votre mot de passe.",
    "inBusy": "Connexion…",
    "inNew": "Nouveau ici ?",
    "inCreate": "Créer un compte",
    "inFail": "Connexion impossible.",
    "upKicker": "Ouvrir un compte",
    "upH": "Inscrivez-vous pendant que le marché est ouvert.",
    "upP": "Une IA pour la crypto, les actions et l’or. Vitesse, sécurité, et une lecture qui reste allumée.",
    "upTitle": "Inscription",
    "upH2": "Créez votre compte",
    "upName": "Nom complet",
    "upNameErr": "Dites-nous comment vous appeler.",
    "upEmailErr": "Entrez un e-mail valide.",
    "upPhone": "Téléphone",
    "upCode": "Indicatif du pays",
    "upCodeShort": "Code",
    "upCodePh": "Pays ou indicatif",
    "upNoCountry": "Aucun pays ne correspond.",
    "upNumber": "Numéro",
    "upReal": "Entrez un vrai",
    "upReal2": "numéro.",
    "upChooseCode": "Choisissez l’indicatif, puis le numéro.",
    "upCountry": "Pays",
    "upSelect": "Choisir un pays",
    "upCountryErr": "Choisissez votre pays.",
    "upPassErr": "Utilisez au moins 8 caractères.",
    "upConfirm": "Confirmer le mot de passe",
    "upMismatch": "Ces mots de passe ne correspondent pas.",
    "upBusy": "Création…",
    "upCreate": "Créer le compte",
    "detKicker": "Informations personnelles",
    "detH": "Nous voulons mieux vous connaître",
    "detP": "Quelques détails, puis vous pouvez ouvrir Dépôt.",
    "detAddress": "Adresse",
    "detCity": "Ville",
    "detZip": "Code postal",
    "detResidence": "Pays de résidence",
    "detNation": "Nationalité",
    "detBirth": "Date de naissance",
    "detBirthHint": "JJ.MM.AAAA",
    "detBirthErr": "Entrez une date réelle au format JJ.MM.AAAA.",
    "detEmpty": "Remplissez chaque champ.",
    "detProceed": "Continuer",
    "detBusy": "Enregistrement…",
    "upAlready": "Déjà inscrit ?",
    "upFail": "Impossible d’ouvrir le compte.",
    "trMissing": "Ce marché n’est pas sur l’IA.",
    "trMissingP": "CapiTrade garde une liste courte. Choisissez un autre nom sur le marché.",
    "trBack": "Retour aux marchés",
    "trOpen": "Ouverture",
    "trHigh": "Plus haut",
    "trLow": "Plus bas",
    "trVolume": "Volume",
    "trSession": "Séance",
    "trCandles": "bougies",
    "trSide": "Sens de l’ordre",
    "trBuy": "Acheter",
    "trSell": "Vendre",
    "trQty": "Quantité",
    "trFill": "Exécution est.",
    "trNotional": "Notionnel",
    "trCash": "Cash",
    "trSending": "Envoi…",
    "trWatchOff": "Retirer de la liste",
    "trWatchOn": "Ajouter à la liste",
    "trSign": "Connectez-vous pour trader",
    "trNew": "Nouveau sur l’IA ?",
    "trOpenAcc": "Ouvrir un compte",
    "trFine": "Ordre au marché. S’exécute tout de suite au touché, plus un écart de 0,02 %.",
    "trOpening": "Ouverture du marché…",
    "trWatchFail": "Impossible de mettre à jour la liste.",
    "trOrderFail": "L’ordre n’a pas été exécuté.",
    "trQtyZero": "Entrez une quantité supérieure à zéro.",
    "trFilled": "Exécuté {side} {qty} {symbol} à {price}.",
    "trTicket": "Ticket",
    "pfKicker": "Profil",
    "pfP": "Les détails enregistrés sur ce compte.",
    "pfDetails": "Détails du profil",
    "pfName": "Nom",
    "pfEmail": "E-mail",
    "pfPhone": "Téléphone",
    "pfCountry": "Pays",
    "pfCash": "Cash",
    "pfMissing": "Non renseigné",
    "pfBack": "Retour à l’IA",
    "poDeposit": "Dépôt",
    "poMarkets": "Marchés",
    "poBot": "Bot IA",
    "poIq": "InvestIQ",
    "poGet": "Obtenir le bot",
    "poHelp": "Aide",
    "poProfile": "Profil",
    "poEquity": "Fonds propres",
    "poPnl": "P&L",
    "poWatch": "Liste de suivi",
    "poMovers": "Plus forts mouvements",
    "poSell": "Vendre",
    "poBuy": "Acheter",
    "poEmpty": "La liste de suivi est vide.",
    "poChart": "Ouverture du graphique…",
    "poSymbol": "Symbole",
    "poDay": "Jour",
    "poLast": "dernier",
    "poPositions": "Positions ouvertes",
    "poFills": "Exécutions récentes",
    "poNoPos": "Vous n’avez aucune position ouverte.",
    "poNoPosB": "Achetez depuis la liste et la position apparaît ici.",
    "poQty": "Qté",
    "poAvg": "Moy.",
    "poNoFills": "Aucune exécution pour l’instant.",
    "poNoFillsB": "Un ordre au marché arrive ici dès qu’il est exécuté.",
    "poSide": "Sens",
    "poPrice": "Prix",
    "poTime": "Heure",
    "poOpeningAcc": "Ouverture du compte…",
    "poLoadFail": "Impossible de charger le compte.",
    "poPay": "Paiement crypto",
    "poConfirmed": "Une fois votre dépôt confirmé chez nous, nous vérifierons votre paiement et l’ajouterons à votre solde. Vous recevrez ensuite votre bonus et l’accès aux fonctions de votre compte.",
    "poChoose": "Choisissez votre type de compte",
    "poAccounts": "Comptes",
    "poMin": "Dépôt minimum",
    "poNext": "Suivant",
    "poGreat": "Excellent choix",
    "poPeople": "personnes ont choisi",
    "poStarted": "et ont commencé à trader.",
    "poNetwork": "Choisissez votre réseau",
    "poNetworks": "Réseaux",
    "poBack": "Retour",
    "poCopied": "Copié",
    "poCopy": "Copier l’adresse",
    "poSendOnly": "Envoyez seulement",
    "poOn": "sur le réseau",
    "poNetworkWord": ".",
    "poAfter": "Après l’envoi, prévenez l’IA sur Telegram.",
    "poLastPrice": "Dernier prix",
    "poStats": "Stats",
    "poAnalysis": "Analyse",
    "poIndicators": "Indicateurs",
    "poTape": "Lu sur le ruban.",
    "poBotAlt": "Un bot de trading IA devant des écrans de marché.",
    "poBotTitle": "Bot de trading IA",
    "poBotP": "Le bot reste sur le ruban pour vous. Il suit la tendance, le RSI et les moyennes mobiles, et il travaille le compte pendant que vous n’êtes pas devant l’écran.",
    "poBotAccess": "Déposez sur votre compte pour accéder au bot.",
    "poHelpTitle": "Parler à l’IA",
    "poHelpP": "Choisissez une question. Le chat répond, puis propose l’étape suivante. Il ne vous dira pas quoi acheter.",
    "poExplain": "Expliquer l’IA",
    "poReadM": "Lire un marché",
    "poOpenMine": "Ouvrir mon compte",
    "askTitle": "Assistant IA",
    "askSub": "Une question à la fois. Ce n’est pas un conseil en investissement.",
    "askStart": "Par où commencer ? Je réponds une étape à la fois, et je ne vous dirai pas quoi acheter.",
    "askPh": "Ou écrivez votre propre question",
    "askSend": "Envoyer",
    "askReplying": "L’IA répond.",
    "askOffline": "Il me faut l’API sur le port 8080 avant de pouvoir répondre. Démarrez-la, puis redemandez.",
    "lgHome": "Page d’accueil",
    "lgPdf": "Ouvrir la politique de confidentialité (PDF)",
    "lgTermsT": "Conditions d’utilisation",
    "lgTerms1": "Ces conditions décrivent l’usage possible du bureau d’entraînement CapiTrade. Les conditions d’exploitation complètes seront publiées ici une fois le nom légal, le pays et le numéro d’enregistrement confirmés.",
    "lgTerms2": "Le contenu de ce site est fourni à titre d’information générale uniquement. Ce n’est pas un conseil en investissement, une recommandation, ni une offre d’achat ou de vente d’un actif. Il ne tient pas compte de vos objectifs personnels, de votre situation financière ou de vos besoins.",
    "lgTerms3": "CapiTrade est exploité par CapiTrade, enregistré en Afrique du Sud sous le numéro 2021/630672/05.",
    "lgPrivT": "Politique de confidentialité",
    "lgPriv1": "La politique de confidentialité est le PDF ci-dessous. Elle couvre ce que CapiTrade collecte, pourquoi, et les droits que vous avez au titre de la POPIA.",
    "lgCookT": "Politique de cookies",
    "lgCook1": "Le site enregistre un jeton de connexion dans le navigateur pour que le compte reste ouvert. Il n’affiche pas de bandeau marketing et ne dépose pas de cookies publicitaires. Vous pouvez effacer le jeton en vous déconnectant, ou en effaçant les données de ce site dans votre navigateur.",
    "lgAmlT": "Politique LBC",
    "lgAml1": "Un dépôt confirmé est vérifié avant d’être ajouté à un solde. La politique complète de lutte contre le blanchiment sera publiée ici une fois le nom légal, le pays et le numéro d’enregistrement confirmés.",
    "lgRiskT": "Avertissement sur les risques",
    "lgRisk1": "Le trading de cryptomonnaies et d’autres instruments financiers comporte un niveau de risque élevé et vous pouvez perdre une partie de votre capital. Les performances passées, y compris les résultats de stratégies automatisées ou fondées sur l’IA, ne garantissent pas les résultats futurs. Ne tradez qu’avec de l’argent que vous pouvez vous permettre de perdre.",
    "lgRisk2": "Le contenu de ce site est fourni à titre d’information générale uniquement. Ce n’est pas une recommandation, ni une offre d’achat ou de vente d’un actif. Il ne tient pas compte de vos objectifs personnels, de votre situation financière ou de vos besoins. Avant de trader, assurez-vous que les produits proposés correspondent à vos objectifs et à votre tolérance au risque, et demandez un avis indépendant si besoin.",
    "iqNoCandles": "Le ruban n’a pas encore 14 bougies, donc le RSI, le MACD et les moyennes ne peuvent pas être calculés.",
    "iqRsiLine": "Le RSI (14) de {symbol} est à {rsi}{shift}. {note}",
    "iqShiftUp": ", en hausse depuis {prior} il y a trois bougies",
    "iqShiftDown": ", en baisse depuis {prior} il y a trois bougies",
    "iqShiftFlat": ", presque inchangé depuis {prior} il y a trois bougies",
    "iqRsiHigh": "Une lecture au-dessus de 70 signifie que les 14 dernières bougies ont monté bien plus vite qu’elles n’ont baissé.",
    "iqRsiLow": "Une lecture sous 30 signifie que les 14 dernières bougies ont baissé bien plus vite qu’elles n’ont monté.",
    "iqRsiMid": "C’est le milieu de l’échelle de 0 à 100, donc les hausses et les baisses récentes sont proches.",
    "iqMacdLine": "Le MACD est à {line}, {side} son signal à {signal}, et {hist}.",
    "iqAbove": "au-dessus de",
    "iqBelow": "en dessous de",
    "iqHistPosWide": "l’histogramme est positif et s’élargit",
    "iqHistPosNarrow": "l’histogramme est positif et se resserre",
    "iqHistNegWide": "l’histogramme est négatif et s’élargit",
    "iqHistNegNarrow": "l’histogramme est négatif et se resserre",
    "iqHistPos": "l’histogramme est positif",
    "iqHistNeg": "l’histogramme est négatif",
    "iqHistFlat": "l’histogramme est plat",
    "iqPrice20": "Le prix est {side} la moyenne 20 périodes à {price}.",
    "iqPrice2050": "Le prix est {a} la moyenne 20 périodes à {p20} et {b} la moyenne 50 périodes à {p50}.",
    "iqBandUp": "Le prix est en dehors de la bande de Bollinger supérieure à {price}.",
    "iqBandDown": "Le prix est en dehors de la bande de Bollinger inférieure à {price}.",
    "iqBandIn": "Le prix est à l’intérieur des bandes de Bollinger, de {low} à {high}.",
    "iqStochTop": "Le stochastique %K est à {value}, près du haut de sa plage de 14 bougies.",
    "iqStochBot": "Le stochastique %K est à {value}, près du bas de sa plage de 14 bougies.",
    "iqStoch": "Le stochastique %K est à {value}.",
    "iqAtrLine": "La moyenne vraie (14) est de {range}.",
    "iqSession": "Sur la séance, le prix est à {above} au-dessus du plus bas et à {under} sous le plus haut, à {pct} % de la plage.",
    "iqSelect": "Choisissez un symbole pour lire la séance.",
    "iqPlace": "La dernière impression est à {pct} % du chemin entre le plus bas de séance {low} et le plus haut de séance {high}.",
    "iqStretched": "Tendu",
    "iqWashed": "Lessivé",
    "iqFirm": "Ferme",
    "iqSoft": "Mou",
    "iqNeutral": "Neutre",
    "iqRsiName": "RSI (14)",
    "iqMacdName": "MACD (12, 26)",
    "iqSignalName": "Signal (9)",
    "iqHistName": "Histogramme",
    "iqSma20Name": "MMS 20",
    "iqSma50Name": "MMS 50",
    "iqBollUpName": "Bollinger supérieure",
    "iqBollLoName": "Bollinger inférieure",
    "iqStochName": "Stochastique %K",
    "iqAtrName": "ATR (14)",
    "iqMacdNote": "Moyenne rapide moins moyenne lente",
    "iqSignalNote": "Moyenne sur 9 périodes du MACD",
    "iqBollUpNote": "Moyenne 20 périodes plus 2 écarts",
    "iqBollLoNote": "Moyenne 20 périodes moins 2 écarts",
    "iqAtrNote": "Moyenne vraie des 14 dernières bougies",
    "iqNeeds15": "Il faut 15 clôtures",
    "iqNeeds35": "Il faut 35 clôtures",
    "iqNeeds14": "Il faut 14 bougies",
    "iqNeedsMore": "Il faut plus de bougies pour {label}",
    "iqAboveLabel": "Le prix est au-dessus de {label}",
    "iqBelowLabel": "Le prix est en dessous de {label}",
    "iqRsiStretchNote": "Tendu, au-dessus de 70",
    "iqRsiWashNote": "Lessivé, sous 30",
    "iqRsiMidNote": "Milieu de l’échelle",
    "iqStochTopNote": "Près du haut de la plage",
    "iqStochBotNote": "Près du bas de la plage",
    "iqStochMidNote": "Proche du plus haut et du plus bas des 14 bougies",
    "iqAvg20": "la moyenne 20 périodes",
    "iqAvg50": "la moyenne 50 périodes",
    "trustOpening": "Ouverture de Trust Wallet sur cette page…",
    "trustConnected": "Trust Wallet est ouvert. Votre adresse sur cette page :",
    "trustMissing": "Trust Wallet n’est pas installé dans ce navigateur. Ajoutez l’extension Trust Wallet, puis ouvrez-la de nouveau ici. Cela reste sur cette page de dépôt.",
    "trustClosed": "Trust Wallet a été fermé.",
    "trustRetry": "Ouvrir Trust Wallet",
    "trustDownload": "Obtenir Trust Wallet"
  },
  ar: {
    "menu": "القائمة",
    "close": "إغلاق",
    "signOut": "تسجيل الخروج",
    "account": "الحساب",
    "noMatch": "لا يوجد رمز مطابق.",
    "jump": "الانتقال إلى رمز",
    "tradingAccounts": "حسابات التداول",
    "navProducts": "المنتجات",
    "navEquities": "الأسهم",
    "navEquitiesSub": "أسهم قائمة الصباح.",
    "navIndexes": "المؤشرات",
    "navIndexesSub": "SPY و QQQ.",
    "navCrypto": "العملات الرقمية",
    "navCryptoSub": "بتكوين وإيثر.",
    "navFx": "العملات",
    "navFxSub": "زوج اليورو والدولار.",
    "navMetals": "المعادن",
    "navMetalsSub": "الذهب، مُسعَّر كـ XAUUSD.",
    "navAi": "الذكاء الاصطناعي",
    "navAll": "كل الأسواق",
    "navAllSub": "القائمة الكاملة.",
    "navPractice": "أمر تدريبي",
    "navPracticeSub": "اختر اسمًا ثم أرسل التذكرة.",
    "navPlatform": "المنصة",
    "navRead": "قراءة الذكاء الاصطناعي",
    "navReadSub": "الذكاء الاصطناعي يسمّي المتصدر. أنت ترسل الأمر.",
    "navYours": "حسابك",
    "navYoursIn": "الاسم والبريد ورصيد التدريب.",
    "navYoursOut": "حساب تدريب مموَّل.",
    "navAcc": "الحسابات",
    "navOverview": "نظرة على الحسابات",
    "navOverviewSub": "من 250$ إلى 100,000$.",
    "navPortSub": "النقد والمراكز والأوامر.",
    "navOpenSub": "يبدأ الرصيد من 0$.",
    "navSignSub": "العودة إلى الذكاء الاصطناعي.",
    "navFourSub": "من التسجيل إلى أول أمر.",
    "navListSub": "قائمة قصيرة، عن قصد.",
    "navSupportSub": "دعم عالمي من الذكاء الاصطناعي.",
    "navAiSub": "ما بُني CapiTrade ليفعله.",
    "navClientsSub": "ماذا يقولون بعد الجلسة.",
    "navTelegram": "تيليغرام.",
    "navTheRead": "القراءة",
    "navTheReadSub": "الذكاء الاصطناعي يراقب. أنت ترسل الأمر.",
    "navHowStarts": "كيف يبدأ",
    "navHowStartsSub": "افتح الحساب ثم اختر سوقًا.",
    "footBlurb": "أدوات تداول بمساعدة الذكاء الاصطناعي للعملات الرقمية والأسواق العالمية.",
    "footRisk": "تحذير من المخاطر. ينطوي تداول العملات الرقمية والأدوات المالية الأخرى على مستوى عالٍ من المخاطر، وقد تخسر جزءًا من رأس مالك. الأداء السابق، بما في ذلك نتائج الاستراتيجيات الآلية أو القائمة على الذكاء الاصطناعي، لا يضمن النتائج المستقبلية. تداول فقط بأموال يمكنك تحمّل خسارتها.",
    "footRiskLink": "اقرأ بيان المخاطر كاملًا.",
    "footInfo": "محتوى هذا الموقع للمعلومات العامة فقط. ليس توصية ولا عرضًا لشراء أو بيع أي أصل. ولا يأخذ في الحسبان أهدافك الشخصية أو وضعك المالي أو احتياجاتك. قبل التداول، تأكد أن المنتجات المعروضة تناسب أهدافك وقدرتك على تحمّل المخاطر، واطلب مشورة مستقلة إذا لزم الأمر.",
    "footOperator": "تُشغَّل CapiTrade بواسطة CapiTrade، المسجّلة في جنوب أفريقيا تحت الرقم 2021/630672/05. المكتب المسجّل: First Floor Kgabo Mashego, Eremomela Avenue, 1749, جنوب أفريقيا. تقدّم CapiTrade أدوات برمجية فقط. وهي لا تقدّم استشارة استثمارية ولا تحتفظ بأموال العملاء. هذا الموقع غير موجَّه إلى المقيمين في أي ولاية قضائية يكون استخدامها فيها مخالفًا للقانون أو التنظيم المحلي.",
    "footRights": "جميع الحقوق محفوظة.",
    "footTerms": "شروط الخدمة",
    "footPrivacy": "سياسة الخصوصية",
    "footCookies": "سياسة ملفات الارتباط",
    "footAml": "سياسة مكافحة غسل الأموال",
    "footRiskName": "بيان المخاطر",
    "footHours": "من الإثنين إلى الجمعة، من 9:00 إلى 18:00",
    "footPolicies": "السياسات",
    "docTitle": "CapiTrade — تداول بالذكاء الاصطناعي",
    "homeWelcome1": "افتح عالم",
    "homeWelcome2": "التداول مع",
    "homeWelcome3": "الذكاء الاصطناعي.",
    "homeH1": "منصة تداول",
    "homeH1em": "آلية بالكامل.",
    "homeLede": "وكلاء تداول بالذكاء الاصطناعي بسرعة وأمان وثبات.",
    "homeTrade": "تداول الآن",
    "homeDeposit": "أول إيداع",
    "homeLicensed": "® مرخّص ومنظَّم",
    "homeAltScreen": "شاشة تداول داكنة بالذكاء الاصطناعي مع رسم ذهبي على الشاشة.",
    "homeAltTrader": "متداولة تبتسم لسعر على هاتفها.",
    "homeEdge": "سوق العملات الرقمية لا ينام، وميزتك كذلك.",
    "homeP1": "بتكوين وبقية السوق يتحركان الآن. في كل دقيقة يتكوّن زخم جديد، ويظهر متصدرون جدد، وتظهر فرص ثم تختفي. يمسح روبوت التداول بالذكاء الاصطناعي أسواق العملات الرقمية على مدار الساعة، ويقرأ السعر والحجم والزخم عبر عشرات الأصول، ثم يسمّي أقوى المرشحين حتى لا تضطر إلى مطاردتهم.",
    "homeP2": "تبقى أنت المتحكم. الروبوت يراقب ويفرز ويشير. أنت تقرر وترسل الأمر. وهو لا يتداول نيابة عنك أبدًا.",
    "homeWhy": "لماذا يختاره المتداولون",
    "homeSpeed": "السرعة",
    "homeSpeedBody": "تتحدّث الإشارات في الوقت الحقيقي، فترى الحركة ما دامت مهمة.",
    "homeSecurity": "الأمان",
    "homeSecurityBody": "قراراتك وحسابك وأموالك. الروبوت لا يمسك المفاتيح أبدًا.",
    "homeReliable": "الثبات",
    "homeReliableBody": "لا إرهاق ولا تشتيت ولا تنبيه فائت. يعمل السوق وأنت تعيش حياتك.",
    "homeRegister": "السوق لن يبطئ لأحد. سجّل اليوم وضع محلّل ذكاء اصطناعي إلى جانبك ما دامت الفرصة قائمة.",
    "homePlaying": "يعمل",
    "homeFilm": "فيلم الذكاء الاصطناعي · 00:18",
    "homeQuiet": "صفقة أهدأ",
    "homeMorning": "سوق الصباح",
    "homeLive": "مباشر",
    "homeOffline": "السوق غير متصل. شغّل واجهة البرمجة على المنفذ 8080.",
    "homeOpening": "جارٍ فتح السوق…",
    "homeTradeNvda": "تداول NVIDIA",
    "homeDepKicker": "اجعل أول إيداع رقمي لك يُحسب",
    "homeDepH": "اجعل أول إيداع رقمي لك",
    "homeDepEm": "يُحسب.",
    "homeDepP": "موّل حسابك بالعملات الرقمية لأول مرة واحصل على مكافأة ترحيب تصل إلى 50% على أول إيداع. ثم دع روبوت التداول بالذكاء الاصطناعي يعمل في السوق من أجلك.",
    "homeHow": "كيف يعمل",
    "homeLi1": "سجّل",
    "homeLi1b": "وافتح حسابك خلال دقائق.",
    "homeLi2": "أودِع عملات رقمية",
    "homeLi2b": "(BTC وETH وUSDT وغيرها) لأول مرة.",
    "homeLi3": "استلم مكافأتك",
    "homeLi3b": "واحصل على روبوت التداول بالذكاء الاصطناعي الخاص بك.",
    "homeLi4": "دع الروبوت يدير حسابك",
    "homeLi4b": "، فيمسح السوق على مدار الساعة ويتصرف عند الفرص، حتى لا تضطر إلى مراقبة كل حركة.",
    "homeFine": "العرض للمستخدمين الجدد فقط. يُطبَّق حد أدنى للإيداع قدره 250$. المكافأة خاضعة لمتطلبات حجم التداول. ينطوي تداول العملات الرقمية على مخاطر خسارة مرتفعة. يطبّق روبوت التداول بالذكاء الاصطناعي وأدوات إدارة المحفظة أساليب إدارة المخاطر، مثل حجم الصفقة وقواعد وقف الخسارة، لتبقى منضبطًا في الأسواق المتقلبة.",
    "homeSupport": "دعم عالمي",
    "homeGlobal": "خدمة عالمية",
    "homeAssist": "مساعدة على مدار الساعة",
    "homeAccess": "وصول إلى الأسواق حول العالم",
    "homeMulti": "دعم بعدة لغات",
    "homeLiveRead": "قراءة مباشرة",
    "homeFocusA": "ابقَ مع الاسم الذي تستطيع شرحه.",
    "homeFocusB": "يتصدر السوق المباشر عند",
    "homePaceA": "أسواق مرتفعة. لست بحاجة إليها كلها. اختر واحدًا واترك الباقي في السوق.",
    "homePaceOf": "من",
    "homeNerveA": "هي الطباعة الثقيلة عند",
    "homeNerveB": "حدّد حجم الصفقة قبل أن تطارد الشعور.",
    "homeAnother": "قراءة أخرى",
    "homeWait": "الذكاء الاصطناعي ينتظر أول طباعة. شغّل واجهة البرمجة، وستتبع القراءة السوق.",
    "homeAsk": "اسأل الذكاء الاصطناعي",
    "homeReadPrices": "قراءة الأسعار المباشرة.",
    "homeM1": "سجّل والسوق ما زال مطلوبًا.",
    "homeM2": "دع الذكاء الاصطناعي يسمّي المتصدر.",
    "homeM3": "أول إيداع هو نقد تدريبي. ثم أرسل الأمر.",
    "homeClients": "العملاء",
    "homeReviews": "ماذا يقولون بعد الجلسة الأولى.",
    "homeStars": "5 نجوم",
    "homeR1t": "عملات رقمية",
    "homeR1": "أودعت وحصلت على مكافأتي وكان الروبوت يعمل في اليوم نفسه. الإعداد استغرق دقائق وكان سهل المتابعة.",
    "homeR2t": "أسهم",
    "homeR2": "كنت أحدّق في الرسوم طوال اليوم. الآن الروبوت يراقب السوق على مدار الساعة، وأنا أراجع عندما يناسبني.",
    "homeR3t": "الذهب وبتكوين",
    "homeR3": "ما يعجبني هو الانضباط. الروبوت يتبع قواعد مخاطره حتى حين كنت سأفزع.",
    "homeMarkets": "الأسواق",
    "homeShort": "قائمة قصيرة، عن قصد.",
    "homeAll": "كل الأسواق",
    "homeThMarket": "السوق",
    "homeThSession": "الجلسة",
    "homeThLast": "الأخير",
    "homeThChange": "التغيّر",
    "homeEmpty": "بانتظار أول طباعة.",
    "homeFourK": "ابدأ في أربع خطوات",
    "homeFourH": "من التسجيل إلى أول صفقة مدعومة بالذكاء الاصطناعي خلال دقائق.",
    "homeS1": "افتح حسابًا",
    "homeS1b": "أنشئ حسابك. أدخل اسمك وبريدك وكلمة المرور. التحقق يستغرق دقائق قليلة.",
    "homeS2": "اختر سوقًا",
    "homeS2b": "قم بأول إيداع. موّل حسابك بـ BTC أو ETH أو USDT أو عملة رقمية مدعومة أخرى (الحد الأدنى 250$) واطلب مكافأة الترحيب حتى 50%.",
    "homeS3": "أرسل أمرًا بسعر السوق",
    "homeS3b": "فعّل روبوت التداول بالذكاء الاصطناعي. اختر أسواقك وإعدادات المخاطر، ويبدأ الروبوت بمسح السوق على مدار الساعة.",
    "homeS4": "راجع الحساب",
    "homeS4b": "تابع كل شيء مباشرة. رصيدك وحقوق الملكية والربح والخسارة تتحدّث في الوقت الحقيقي. عدّل إعداداتك أو اسحب متى شئت، وفق شروط المكافأة.",
    "homeNow": "سجّل الآن",
    "homePartners": "شراكات",
    "homeCloseH": "الطباعة الأقوى لن تنتظر",
    "homeCloseEm": "حسابًا فارغًا.",
    "homeCloseP": "افتح حسابك اليوم، وقم بأول إيداع رقمي بقيمة 250$ أو أكثر، واحصل على مكافأة ترحيب تصل إلى 50%. يبدأ روبوت التداول بالذكاء الاصطناعي العمل فورًا.",
    "mktKicker": "السوق",
    "mktTitle": "الأسواق",
    "mktLede": "خمسة عشر اسمًا. ابحث وصفِّ وافتح تذكرة.",
    "mktSearch": "ابحث في الأسواق",
    "mktPh": "الرمز أو الاسم",
    "mktClass": "فئة الأصل",
    "mktMarket": "السوق",
    "mktClassCol": "الفئة",
    "mktTrend": "الاتجاه",
    "mktLast": "الأخير",
    "mktChange": "التغيّر",
    "mktVolume": "الحجم",
    "mktOffline": "الذكاء الاصطناعي غير متصل. شغّل واجهة البرمجة ثم حدّث.",
    "mktOpening": "جارٍ فتح السوق…",
    "mktNone": "لا شيء يطابق هذا البحث.",
    "classALL": "الكل",
    "classEQUITY": "الأسهم",
    "classINDEX": "المؤشرات",
    "classCRYPTO": "العملات الرقمية",
    "classFX": "العملات",
    "classCOMMODITY": "المعادن",
    "oneEQUITY": "سهم",
    "oneINDEX": "مؤشر",
    "oneCRYPTO": "عملة رقمية",
    "oneFX": "عملة",
    "oneCOMMODITY": "معدن",
    "accTitle": "الحسابات",
    "accPort": "محفظتك",
    "accOpen": "افتح حسابًا",
    "accRange": "من 250$ إلى 100,000$.",
    "accFrom": "من",
    "accClassic": "حساب Classic",
    "accClassicLine": "وصول بسيط. نظرة أولى على السوق، مع دعم حين تطلبه.",
    "accSilver": "حساب Silver",
    "accSilverLine": "تعرّض أوسع للسوق، روبوت تداول واحد، دعم على مدار الساعة، ومدير حساب واحد عند الطلب.",
    "accGold": "حساب Gold",
    "accGoldLine": "تعرّض أوسع للسوق، مزيد من روبوتات التداول، دعم على مدار الساعة، ومديران للحساب عند الطلب.",
    "accPlat": "حساب Platinum",
    "accPlatLine": "تعرّض عميق للسوق، مجموعة أقوى من روبوتات التداول، دعم ذو أولوية على مدار الساعة، و3 مديري حساب.",
    "accVip": "حساب VIP",
    "accVipLine": "وصول كامل إلى مستشار مالي ومن 1 إلى 5 مديري حساب، مع كل روبوتات التداول وأوسع تعرّض للسوق.",
    "inKicker": "حسابك",
    "inH": "السوق لا ينتظر.",
    "inP": "عُد إلى العملات الرقمية والأسهم والذهب. سرعة وأمان وقراءة بقيت تعمل.",
    "inSpeed": "السرعة",
    "inSpeedB": "انظر الحركة ما دامت مهمة.",
    "inSec": "الأمان",
    "inSecB": "حسابك. قراراتك.",
    "inRel": "الثبات",
    "inRelB": "الذكاء الاصطناعي لا ينهي دوامه.",
    "inTitle": "تسجيل الدخول",
    "inEmail": "البريد",
    "inEmailErr": "أدخل البريد المسجّل على حسابك.",
    "inPass": "كلمة المرور",
    "inPassErr": "أدخل كلمة المرور.",
    "inBusy": "جارٍ تسجيل الدخول…",
    "inNew": "جديد هنا؟",
    "inCreate": "إنشاء حساب",
    "inFail": "تعذّر تسجيل الدخول.",
    "upKicker": "افتح حسابًا",
    "upH": "سجّل والسوق مفتوح.",
    "upP": "ذكاء اصطناعي للعملات الرقمية والأسهم والذهب. سرعة وأمان وقراءة تبقى تعمل.",
    "upTitle": "التسجيل",
    "upH2": "أنشئ حسابك",
    "upName": "الاسم الكامل",
    "upNameErr": "أخبرنا بما نناديك به.",
    "upEmailErr": "أدخل بريدًا صالحًا.",
    "upPhone": "الهاتف",
    "upCode": "رمز الدولة",
    "upCodeShort": "الرمز",
    "upCodePh": "الدولة أو الرمز",
    "upNoCountry": "لا توجد دولة مطابقة.",
    "upNumber": "الرقم",
    "upReal": "أدخل رقم",
    "upReal2": "حقيقيًا.",
    "upChooseCode": "اختر رمز الدولة ثم الرقم.",
    "upCountry": "الدولة",
    "upSelect": "اختر دولة",
    "upCountryErr": "اختر دولتك.",
    "upPassErr": "استخدم 8 أحرف على الأقل.",
    "upConfirm": "تأكيد كلمة المرور",
    "upMismatch": "كلمتا المرور غير متطابقتين.",
    "upBusy": "جارٍ الإنشاء…",
    "upCreate": "إنشاء الحساب",
    "detKicker": "البيانات الشخصية",
    "detH": "نريد أن نعرفك أكثر",
    "detP": "بعض البيانات، ثم يمكنك فتح الإيداع.",
    "detAddress": "العنوان",
    "detCity": "المدينة",
    "detZip": "الرمز البريدي",
    "detResidence": "بلد الإقامة",
    "detNation": "الجنسية",
    "detBirth": "تاريخ الميلاد",
    "detBirthHint": "DD.MM.YYYY",
    "detBirthErr": "أدخل تاريخًا حقيقيًا بالشكل DD.MM.YYYY.",
    "detEmpty": "املأ كل الحقول.",
    "detProceed": "متابعة",
    "detBusy": "جارٍ الحفظ…",
    "upAlready": "مسجّل من قبل؟",
    "upFail": "تعذّر فتح الحساب.",
    "trMissing": "هذا السوق غير موجود على الذكاء الاصطناعي.",
    "trMissingP": "تُبقي CapiTrade القائمة قصيرة. اختر اسمًا آخر من السوق.",
    "trBack": "العودة إلى الأسواق",
    "trOpen": "الافتتاح",
    "trHigh": "الأعلى",
    "trLow": "الأدنى",
    "trVolume": "الحجم",
    "trSession": "الجلسة",
    "trCandles": "شموع",
    "trSide": "جهة الأمر",
    "trBuy": "شراء",
    "trSell": "بيع",
    "trQty": "الكمية",
    "trFill": "تنفيذ تقديري",
    "trNotional": "القيمة الاسمية",
    "trCash": "النقد",
    "trSending": "جارٍ الإرسال…",
    "trWatchOff": "إزالة من القائمة",
    "trWatchOn": "إضافة إلى القائمة",
    "trSign": "سجّل الدخول للتداول",
    "trNew": "جديد على الذكاء الاصطناعي؟",
    "trOpenAcc": "فتح حساب",
    "trFine": "أمر بسعر السوق. يُنفَّذ فورًا عند اللمس، مع فارق 0.02%.",
    "trOpening": "جارٍ فتح السوق…",
    "trWatchFail": "تعذّر تحديث القائمة.",
    "trOrderFail": "لم يُنفَّذ الأمر.",
    "trQtyZero": "أدخل كمية أكبر من صفر.",
    "trFilled": "تم التنفيذ {side} {qty} {symbol} عند {price}.",
    "trTicket": "التذكرة",
    "pfKicker": "الملف",
    "pfP": "البيانات المحفوظة على هذا الحساب.",
    "pfDetails": "تفاصيل الملف",
    "pfName": "الاسم",
    "pfEmail": "البريد",
    "pfPhone": "الهاتف",
    "pfCountry": "الدولة",
    "pfCash": "النقد",
    "pfMissing": "غير مسجّل",
    "pfBack": "العودة إلى الذكاء الاصطناعي",
    "poDeposit": "إيداع",
    "poMarkets": "الأسواق",
    "poBot": "روبوت الذكاء الاصطناعي",
    "poIq": "InvestIQ",
    "poGet": "احصل على الروبوت",
    "poHelp": "مساعدة",
    "poProfile": "الملف",
    "poEquity": "حقوق الملكية",
    "poPnl": "الربح والخسارة",
    "poWatch": "قائمة المتابعة",
    "poMovers": "الأكثر حركة",
    "poSell": "بيع",
    "poBuy": "شراء",
    "poEmpty": "قائمة المتابعة فارغة.",
    "poChart": "جارٍ فتح الرسم…",
    "poSymbol": "الرمز",
    "poDay": "اليوم",
    "poLast": "الأخير",
    "poPositions": "المراكز المفتوحة",
    "poFills": "التنفيذات الأخيرة",
    "poNoPos": "ليس لديك أي مركز مفتوح.",
    "poNoPosB": "اشترِ من القائمة وسيظهر المركز هنا.",
    "poQty": "الكمية",
    "poAvg": "المتوسط",
    "poNoFills": "لا تنفيذات بعد.",
    "poNoFillsB": "يظهر أمر السوق هنا فور تنفيذه.",
    "poSide": "الجهة",
    "poPrice": "السعر",
    "poTime": "الوقت",
    "poOpeningAcc": "جارٍ فتح الحساب…",
    "poLoadFail": "تعذّر تحميل الحساب.",
    "poPay": "دفع بالعملات الرقمية",
    "poConfirmed": "بعد تأكيد إيداعك لدينا، سنتحقق من دفعتك ونضيفها إلى رصيدك. ثم ستتلقى مكافأتك والوصول إلى ميزات حسابك.",
    "poChoose": "اختر نوع حسابك",
    "poAccounts": "الحسابات",
    "poMin": "الحد الأدنى للإيداع",
    "poNext": "التالي",
    "poGreat": "اختيار موفق",
    "poPeople": "أشخاص اختاروا",
    "poStarted": "وبدأوا التداول.",
    "poNetwork": "اختر شبكتك",
    "poNetworks": "الشبكات",
    "poBack": "رجوع",
    "poCopied": "تم النسخ",
    "poCopy": "نسخ العنوان",
    "poSendOnly": "أرسل فقط",
    "poOn": "على شبكة",
    "poNetworkWord": ".",
    "poAfter": "بعد الإرسال، أخبر الذكاء الاصطناعي على تيليغرام.",
    "poLastPrice": "آخر سعر",
    "poStats": "الإحصاءات",
    "poAnalysis": "التحليل",
    "poIndicators": "المؤشرات",
    "poTape": "مقروء من الشريط.",
    "poBotAlt": "روبوت تداول بالذكاء الاصطناعي أمام شاشات السوق.",
    "poBotTitle": "روبوت تداول بالذكاء الاصطناعي",
    "poBotP": "يبقى الروبوت على الشريط من أجلك. يتبع الاتجاه ومؤشر RSI والمتوسطات المتحركة، ويعمل على الحساب وأنت بعيد عن الشاشة.",
    "poBotAccess": "أودِع في حسابك للحصول على الروبوت.",
    "poHelpTitle": "تحدث إلى الذكاء الاصطناعي",
    "poHelpP": "اختر سؤالًا واحدًا. يجيب الدردشة ثم يقترح الخطوة التالية. ولن يخبرك بما تشتري.",
    "poExplain": "اشرح الذكاء الاصطناعي",
    "poReadM": "اقرأ سوقًا",
    "poOpenMine": "افتح حسابي",
    "askTitle": "مساعد الذكاء الاصطناعي",
    "askSub": "سؤال واحد في كل مرة. ليست نصيحة استثمارية.",
    "askStart": "من أين نبدأ؟ أجيب خطوة بخطوة، ولن أخبرك بما تشتري.",
    "askPh": "أو اكتب سؤالك",
    "askSend": "إرسال",
    "askReplying": "الذكاء الاصطناعي يرد.",
    "askOffline": "أحتاج واجهة البرمجة على المنفذ 8080 قبل أن أستطيع الإجابة. شغّلها ثم اسأل مرة أخرى.",
    "lgHome": "الصفحة الرئيسية",
    "lgPdf": "افتح سياسة الخصوصية (PDF)",
    "lgTermsT": "شروط الخدمة",
    "lgTerms1": "تصف هذه الشروط كيف يمكن استخدام مكتب التدريب في CapiTrade. ستُنشر شروط التشغيل الكاملة هنا بعد تأكيد الاسم القانوني والدولة ورقم التسجيل.",
    "lgTerms2": "محتوى هذا الموقع للمعلومات العامة فقط. ليس نصيحة استثمارية ولا توصية ولا عرضًا لشراء أو بيع أي أصل. ولا يأخذ في الحسبان أهدافك الشخصية أو وضعك المالي أو احتياجاتك.",
    "lgTerms3": "تُشغَّل CapiTrade بواسطة CapiTrade، المسجّلة في جنوب أفريقيا تحت الرقم 2021/630672/05.",
    "lgPrivT": "سياسة الخصوصية",
    "lgPriv1": "سياسة الخصوصية هي ملف PDF المربوط أدناه. تغطي ما تجمعه CapiTrade ولماذا، والحقوق التي تملكها بموجب POPIA.",
    "lgCookT": "سياسة ملفات الارتباط",
    "lgCook1": "يخزّن الموقع رمز تسجيل الدخول في المتصفح ليبقى الحساب مفتوحًا. ولا يعرض شريط ملفات ارتباط تسويقي ولا يضع ملفات ارتباط إعلانية. يمكنك مسح الرمز بتسجيل الخروج أو بمسح بيانات هذا الموقع من المتصفح.",
    "lgAmlT": "سياسة مكافحة غسل الأموال",
    "lgAml1": "يُراجع الإيداع المؤكَّد قبل إضافته إلى الرصيد. ستُنشر سياسة مكافحة غسل الأموال الكاملة هنا بعد تأكيد الاسم القانوني والدولة ورقم التسجيل.",
    "lgRiskT": "بيان المخاطر",
    "lgRisk1": "ينطوي تداول العملات الرقمية والأدوات المالية الأخرى على مستوى عالٍ من المخاطر، وقد تخسر جزءًا من رأس مالك. الأداء السابق، بما في ذلك نتائج الاستراتيجيات الآلية أو القائمة على الذكاء الاصطناعي، لا يضمن النتائج المستقبلية. تداول فقط بأموال يمكنك تحمّل خسارتها.",
    "lgRisk2": "محتوى هذا الموقع للمعلومات العامة فقط. ليس توصية ولا عرضًا لشراء أو بيع أي أصل. ولا يأخذ في الحسبان أهدافك الشخصية أو وضعك المالي أو احتياجاتك. قبل التداول، تأكد أن المنتجات المعروضة تناسب أهدافك وقدرتك على تحمّل المخاطر، واطلب مشورة مستقلة إذا لزم الأمر.",
    "iqNoCandles": "الشريط لا يملك 14 شمعة بعد، لذلك لا يمكن حساب RSI وMACD والمتوسطات.",
    "iqRsiLine": "مؤشر RSI ‏(14) لـ {symbol} هو {rsi}{shift}. {note}",
    "iqShiftUp": "، مرتفع من {prior} قبل ثلاث شموع",
    "iqShiftDown": "، منخفض من {prior} قبل ثلاث شموع",
    "iqShiftFlat": "، شبه ثابت مقارنة بـ {prior} قبل ثلاث شموع",
    "iqRsiHigh": "قراءة فوق 70 تعني أن آخر 14 شمعة صعدت أسرع بكثير مما هبطت.",
    "iqRsiLow": "قراءة تحت 30 تعني أن آخر 14 شمعة هبطت أسرع بكثير مما صعدت.",
    "iqRsiMid": "هذا منتصف المقياس من 0 إلى 100، لذا فالمكاسب والخسائر الأخيرة متقاربة.",
    "iqMacdLine": "مؤشر MACD عند {line}، {side} إشارته عند {signal}، و{hist}.",
    "iqAbove": "فوق",
    "iqBelow": "تحت",
    "iqHistPosWide": "المدرج موجب ويتسع",
    "iqHistPosNarrow": "المدرج موجب ويضيق",
    "iqHistNegWide": "المدرج سالب ويتسع",
    "iqHistNegNarrow": "المدرج سالب ويضيق",
    "iqHistPos": "المدرج موجب",
    "iqHistNeg": "المدرج سالب",
    "iqHistFlat": "المدرج مسطّح",
    "iqPrice20": "السعر {side} متوسط 20 فترة عند {price}.",
    "iqPrice2050": "السعر {a} متوسط 20 فترة عند {p20} و{b} متوسط 50 فترة عند {p50}.",
    "iqBandUp": "السعر خارج نطاق بولينجر العلوي عند {price}.",
    "iqBandDown": "السعر خارج نطاق بولينجر السفلي عند {price}.",
    "iqBandIn": "السعر داخل نطاقات بولينجر، من {low} إلى {high}.",
    "iqStochTop": "مؤشر ستوكاستك %K عند {value}، قرب أعلى نطاق 14 شمعة.",
    "iqStochBot": "مؤشر ستوكاستك %K عند {value}، قرب أدنى نطاق 14 شمعة.",
    "iqStoch": "مؤشر ستوكاستك %K عند {value}.",
    "iqAtrLine": "متوسط المدى الحقيقي (14) هو {range}.",
    "iqSession": "في الجلسة، السعر أعلى من القاع بمقدار {above} وأدنى من القمة بمقدار {under}، و{pct}% عبر النطاق.",
    "iqSelect": "اختر رمزًا لقراءة الجلسة.",
    "iqPlace": "آخر طباعة عند {pct}% من الطريق بين قاع الجلسة {low} وقمة الجلسة {high}.",
    "iqStretched": "مشدود",
    "iqWashed": "منهك",
    "iqFirm": "ثابت",
    "iqSoft": "ضعيف",
    "iqNeutral": "محايد",
    "iqRsiName": "RSI ‏(14)",
    "iqMacdName": "MACD ‏(12، 26)",
    "iqSignalName": "الإشارة (9)",
    "iqHistName": "المدرج",
    "iqSma20Name": "المتوسط 20",
    "iqSma50Name": "المتوسط 50",
    "iqBollUpName": "بولينجر العلوي",
    "iqBollLoName": "بولينجر السفلي",
    "iqStochName": "ستوكاستك %K",
    "iqAtrName": "ATR ‏(14)",
    "iqMacdNote": "المتوسط السريع ناقص المتوسط البطيء",
    "iqSignalNote": "متوسط 9 فترات لمؤشر MACD",
    "iqBollUpNote": "متوسط 20 فترة زائد انحرافين",
    "iqBollLoNote": "متوسط 20 فترة ناقص انحرافين",
    "iqAtrNote": "متوسط المدى الحقيقي لآخر 14 شمعة",
    "iqNeeds15": "يلزم 15 إغلاقًا",
    "iqNeeds35": "يلزم 35 إغلاقًا",
    "iqNeeds14": "يلزم 14 شمعة",
    "iqNeedsMore": "يلزم مزيد من الشموع لـ {label}",
    "iqAboveLabel": "السعر فوق {label}",
    "iqBelowLabel": "السعر تحت {label}",
    "iqRsiStretchNote": "مشدود، فوق 70",
    "iqRsiWashNote": "منهك، تحت 30",
    "iqRsiMidNote": "منتصف المقياس",
    "iqStochTopNote": "قرب أعلى النطاق",
    "iqStochBotNote": "قرب أدنى النطاق",
    "iqStochMidNote": "قريب من قمة وقاع 14 شمعة",
    "iqAvg20": "متوسط 20 فترة",
    "iqAvg50": "متوسط 50 فترة",
    "trustOpening": "جارٍ فتح Trust Wallet في هذه الصفحة…",
    "trustConnected": "Trust Wallet مفتوح. عنوانك في هذه الصفحة:",
    "trustMissing": "Trust Wallet غير مثبّت في هذا المتصفح. أضف إضافة Trust Wallet، ثم افتحها من هنا مرة أخرى. تبقى في صفحة الإيداع.",
    "trustClosed": "تم إغلاق Trust Wallet.",
    "trustRetry": "افتح Trust Wallet",
    "trustDownload": "احصل على Trust Wallet"
  },
  ms: {
    "menu": "Menu",
    "close": "Tutup",
    "signOut": "Log keluar",
    "account": "Akaun",
    "noMatch": "Tiada simbol yang sepadan.",
    "jump": "Pergi ke simbol",
    "tradingAccounts": "Akaun dagangan",
    "navProducts": "Produk",
    "navEquities": "Ekuiti",
    "navEquitiesSub": "Saham dalam senarai pagi.",
    "navIndexes": "Indeks",
    "navIndexesSub": "SPY dan QQQ.",
    "navCrypto": "Kripto",
    "navCryptoSub": "Bitcoin dan ether.",
    "navFx": "FX",
    "navFxSub": "Pasangan euro dolar.",
    "navMetals": "Logam",
    "navMetalsSub": "Emas, disebut sebagai XAUUSD.",
    "navAi": "AI",
    "navAll": "Semua pasaran",
    "navAllSub": "Senarai penuh.",
    "navPractice": "Pesanan latihan",
    "navPracticeSub": "Pilih nama, kemudian hantar tiket.",
    "navPlatform": "Platform",
    "navRead": "Bacaan AI",
    "navReadSub": "AI menamakan peneraju. Anda hantar pesanan.",
    "navYours": "Akaun anda",
    "navYoursIn": "Nama, e-mel dan baki latihan.",
    "navYoursOut": "Akaun latihan yang telah dibiayai.",
    "navAcc": "Akaun",
    "navOverview": "Gambaran akaun",
    "navOverviewSub": "Dari $250 hingga $100,000.",
    "navPortSub": "Tunai, posisi dan pesanan.",
    "navOpenSub": "Baki bermula pada $0.",
    "navSignSub": "Kembali ke AI.",
    "navFourSub": "Dari pendaftaran ke pesanan pertama.",
    "navListSub": "Senarai pendek, dengan sengaja.",
    "navSupportSub": "Sokongan seluruh dunia daripada AI.",
    "navAiSub": "Apa yang CapiTrade dibina untuk lakukan.",
    "navClientsSub": "Apa yang mereka kata selepas sesi.",
    "navTelegram": "Telegram.",
    "navTheRead": "Bacaan",
    "navTheReadSub": "AI memerhati. Anda hantar pesanan.",
    "navHowStarts": "Bagaimana ia bermula",
    "navHowStartsSub": "Buka akaun, kemudian pilih pasaran.",
    "footBlurb": "Alat dagangan berbantu AI untuk kripto dan pasaran global.",
    "footRisk": "Amaran risiko. Berdagang mata wang kripto dan instrumen kewangan lain melibatkan risiko tinggi dan anda boleh kehilangan sebahagian modal. Prestasi lalu, termasuk hasil strategi automatik atau berasaskan AI, tidak menjamin hasil akan datang. Berdagang hanya dengan wang yang anda mampu kehilangan.",
    "footRiskLink": "Baca pendedahan risiko penuh.",
    "footInfo": "Kandungan laman web ini adalah maklumat umum sahaja. Ia bukan cadangan, atau tawaran untuk membeli atau menjual sebarang aset. Ia tidak mengambil kira objektif peribadi, keadaan kewangan atau keperluan anda. Sebelum berdagang, pastikan produk yang ditawarkan sesuai dengan matlamat dan toleransi risiko anda, dan dapatkan nasihat bebas jika perlu.",
    "footOperator": "CapiTrade dikendalikan oleh CapiTrade, berdaftar di Afrika Selatan di bawah nombor 2021/630672/05. Pejabat berdaftar: First Floor Kgabo Mashego, Eremomela Avenue, 1749, Afrika Selatan. CapiTrade hanya menyediakan alat perisian. Ia tidak memberi nasihat pelaburan dan tidak memegang dana pelanggan. Laman web ini tidak ditujukan kepada penduduk mana-mana bidang kuasa di mana penggunaannya bertentangan dengan undang-undang atau peraturan tempatan.",
    "footRights": "Hak cipta terpelihara.",
    "footTerms": "Terma perkhidmatan",
    "footPrivacy": "Dasar privasi",
    "footCookies": "Dasar kuki",
    "footAml": "Dasar AML",
    "footRiskName": "Pendedahan risiko",
    "footHours": "Isnin hingga Jumaat, 9:00 hingga 18:00",
    "footPolicies": "Dasar",
    "docTitle": "CapiTrade — dagangan AI",
    "homeWelcome1": "Buka dunia",
    "homeWelcome2": "dagangan dengan",
    "homeWelcome3": "AI.",
    "homeH1": "Platform dagangan",
    "homeH1em": "automatik sepenuhnya.",
    "homeLede": "Ejen dagangan AI dengan kelajuan, keselamatan dan kebolehpercayaan.",
    "homeTrade": "Dagang sekarang",
    "homeDeposit": "Deposit pertama",
    "homeLicensed": "® Berlesen dan dikawal selia",
    "homeAltScreen": "Skrin dagangan AI yang gelap dengan carta emas pada monitor.",
    "homeAltTrader": "Seorang pedagang tersenyum pada sebut harga di telefonnya.",
    "homeEdge": "Pasaran kripto tidak pernah tidur, dan kelebihan anda juga tidak.",
    "homeP1": "Bitcoin dan pasaran yang lain sedang bergerak sekarang. Setiap minit, momentum baharu terbina, peneraju baharu muncul, dan peluang baharu datang lalu hilang. Bot dagangan AI kami mengimbas pasaran kripto sepanjang masa, membaca harga, volum dan momentum merentas puluhan aset, kemudian menamakan calon paling kuat supaya anda tidak perlu mengejarnya.",
    "homeP2": "Anda kekal mengawal. Bot yang memerhati, menyusun dan memberi isyarat. Anda yang membuat keputusan dan menghantar pesanan. Ia tidak sekali-kali berdagang bagi pihak anda.",
    "homeWhy": "Mengapa pedagang memilihnya",
    "homeSpeed": "Kelajuan",
    "homeSpeedBody": "Isyarat dikemas kini masa nyata, jadi anda nampak pergerakan selagi ia masih penting.",
    "homeSecurity": "Keselamatan",
    "homeSecurityBody": "Keputusan anda, akaun anda, dana anda. Bot tidak pernah memegang kunci.",
    "homeReliable": "Kebolehpercayaan",
    "homeReliableBody": "Tiada penat, tiada gangguan, tiada amaran terlepas. Ia bekerja pasaran sementara anda menjalani hidup.",
    "homeRegister": "Pasaran tidak akan perlahan untuk sesiapa. Daftar hari ini dan letakkan penganalisis AI di sisi anda selagi peluang masih ada.",
    "homePlaying": "Dimainkan",
    "homeFilm": "Filem AI · 00:18",
    "homeQuiet": "dagangan yang lebih tenang",
    "homeMorning": "Pasaran pagi",
    "homeLive": "Langsung",
    "homeOffline": "Pasaran luar talian. Mulakan API pada port 8080.",
    "homeOpening": "Membuka pasaran…",
    "homeTradeNvda": "Dagang NVIDIA",
    "homeDepKicker": "Jadikan deposit kripto pertama anda bermakna",
    "homeDepH": "Jadikan deposit kripto pertama anda",
    "homeDepEm": "bermakna.",
    "homeDepP": "Biayai akaun anda dengan kripto buat kali pertama dan terima bonus alu-aluan sehingga 50% pada deposit pertama. Kemudian biarkan bot dagangan AI kami bekerja di pasaran untuk anda.",
    "homeHow": "Cara ia berfungsi",
    "homeLi1": "Daftar",
    "homeLi1b": "dan buka akaun anda dalam beberapa minit.",
    "homeLi2": "Deposit kripto",
    "homeLi2b": "(BTC, ETH, USDT dan lagi) buat kali pertama.",
    "homeLi3": "Terima bonus anda",
    "homeLi3b": "dan dapatkan akses kepada bot dagangan AI anda sendiri.",
    "homeLi4": "Biarkan bot mengurus akaun anda",
    "homeLi4b": ", mengimbas pasaran sepanjang masa dan bertindak pada peluang, supaya anda tidak perlu menonton setiap pergerakan.",
    "homeFine": "Tawaran untuk pengguna baharu sahaja. Deposit minimum $250 dikenakan. Bonus tertakluk kepada syarat volum dagangan. Berdagang kripto melibatkan risiko kerugian yang tinggi. Bot dagangan AI dan alat pengurusan portfolio kami menggunakan teknik pengurusan risiko, seperti saiz posisi dan peraturan henti rugi, untuk membantu anda kekal berdisiplin dalam pasaran yang tidak menentu.",
    "homeSupport": "Sokongan seluruh dunia",
    "homeGlobal": "Perkhidmatan global",
    "homeAssist": "Bantuan 24/7",
    "homeAccess": "Akses pasaran seluruh dunia",
    "homeMulti": "Sokongan pelbagai bahasa",
    "homeLiveRead": "Bacaan langsung",
    "homeFocusA": "Kekal dengan nama yang anda boleh terangkan.",
    "homeFocusB": "menerajui pasaran langsung pada",
    "homePaceA": "pasaran lebih tinggi. Anda tidak perlukan semuanya. Pilih satu dan biarkan yang lain di pasaran.",
    "homePaceOf": "daripada",
    "homeNerveA": "ialah cetakan berat pada",
    "homeNerveB": "Ukur dagangan sebelum anda mengejar perasaan.",
    "homeAnother": "Bacaan lain",
    "homeWait": "AI menunggu cetakan pertama. Mulakan API, dan bacaan akan mengikut pasaran.",
    "homeAsk": "Tanya AI",
    "homeReadPrices": "Bacaan harga langsung.",
    "homeM1": "Daftar selagi pasaran masih dibida.",
    "homeM2": "Biarkan AI menamakan peneraju.",
    "homeM3": "Deposit pertama ialah tunai latihan. Kemudian hantar pesanan.",
    "homeClients": "Pelanggan",
    "homeReviews": "Apa yang mereka kata selepas sesi pertama.",
    "homeStars": "5 bintang",
    "homeR1t": "Kripto",
    "homeR1": "Saya deposit, dapat bonus, dan bot saya berjalan hari yang sama. Persediaan mengambil masa beberapa minit, dan mudah diikuti.",
    "homeR2t": "Ekuiti",
    "homeR2": "Dulu saya merenung carta sepanjang hari. Kini bot memantau pasaran sepanjang masa, dan saya semak bila sesuai.",
    "homeR3t": "Emas dan bitcoin",
    "homeR3": "Yang saya suka ialah disiplin. Bot mengikut peraturan risikonya walaupun saya sudah panik.",
    "homeMarkets": "Pasaran",
    "homeShort": "Senarai pendek, dengan sengaja.",
    "homeAll": "Semua pasaran",
    "homeThMarket": "Pasaran",
    "homeThSession": "Sesi",
    "homeThLast": "Akhir",
    "homeThChange": "Perubahan",
    "homeEmpty": "Menunggu cetakan pertama.",
    "homeFourK": "Mula dalam empat langkah",
    "homeFourH": "Dari pendaftaran ke dagangan berkuasa AI pertama anda dalam beberapa minit.",
    "homeS1": "Buka akaun",
    "homeS1b": "Cipta akaun anda. Masukkan nama, e-mel dan kata laluan. Pengesahan hanya mengambil beberapa minit.",
    "homeS2": "Pilih pasaran",
    "homeS2b": "Buat deposit pertama anda. Biayai akaun dengan BTC, ETH, USDT atau kripto lain yang disokong (minimum $250) dan tuntut bonus alu-aluan sehingga 50%.",
    "homeS3": "Hantar pesanan pasaran",
    "homeS3b": "Aktifkan bot dagangan AI anda. Pilih pasaran dan tetapan risiko, dan bot anda mula mengimbas pasaran sepanjang masa.",
    "homeS4": "Semak akaun",
    "homeS4b": "Jejak semuanya secara langsung. Baki, ekuiti, serta untung dan rugi dikemas kini masa nyata. Laraskan tetapan atau keluarkan bila-bila masa, tertakluk kepada terma bonus.",
    "homeNow": "Daftar sekarang",
    "homePartners": "Perkongsian",
    "homeCloseH": "Cetakan yang lebih kuat tidak akan menunggu",
    "homeCloseEm": "akaun kosong.",
    "homeCloseP": "Buka akaun anda hari ini, buat deposit kripto pertama $250 atau lebih, dan terima bonus alu-aluan sehingga 50%. Bot dagangan AI anda mula bekerja serta-merta.",
    "mktKicker": "Pasaran",
    "mktTitle": "Pasaran",
    "mktLede": "Lima belas nama. Cari, tapis dan buka tiket.",
    "mktSearch": "Cari pasaran",
    "mktPh": "Simbol atau nama",
    "mktClass": "Kelas aset",
    "mktMarket": "Pasaran",
    "mktClassCol": "Kelas",
    "mktTrend": "Trend",
    "mktLast": "Akhir",
    "mktChange": "Perubahan",
    "mktVolume": "Volum",
    "mktOffline": "AI luar talian. Mulakan API, kemudian muat semula.",
    "mktOpening": "Membuka pasaran…",
    "mktNone": "Tiada yang sepadan dengan carian itu.",
    "classALL": "Semua",
    "classEQUITY": "Ekuiti",
    "classINDEX": "Indeks",
    "classCRYPTO": "Kripto",
    "classFX": "FX",
    "classCOMMODITY": "Logam",
    "oneEQUITY": "Ekuiti",
    "oneINDEX": "Indeks",
    "oneCRYPTO": "Kripto",
    "oneFX": "FX",
    "oneCOMMODITY": "Logam",
    "accTitle": "Akaun",
    "accPort": "Portfolio anda",
    "accOpen": "Buka akaun",
    "accRange": "Dari $250 hingga $100,000.",
    "accFrom": "Dari",
    "accClassic": "Akaun Classic",
    "accClassicLine": "Akses mudah. Pandangan pertama pada pasaran, dengan sokongan bila anda minta.",
    "accSilver": "Akaun Silver",
    "accSilverLine": "Pendedahan pasaran lebih luas, satu bot dagangan, sokongan 24/7, dan 1 pengurus akaun atas permintaan.",
    "accGold": "Akaun Gold",
    "accGoldLine": "Pendedahan pasaran lebih luas lagi, lebih banyak bot dagangan, sokongan 24/7, dan 2 pengurus akaun atas permintaan.",
    "accPlat": "Akaun Platinum",
    "accPlatLine": "Pendedahan pasaran dalam, set bot dagangan yang lebih kuat, sokongan keutamaan 24/7, dan 3 pengurus akaun.",
    "accVip": "Akaun VIP",
    "accVipLine": "Akses penuh kepada penasihat kewangan dan 1–5 pengurus akaun, dengan setiap bot dagangan dan pendedahan pasaran paling luas.",
    "inKicker": "Akaun anda",
    "inH": "Pasaran tidak menunggu.",
    "inP": "Kembali ke kripto, saham dan emas. Kelajuan, keselamatan, dan bacaan yang kekal hidup.",
    "inSpeed": "Kelajuan",
    "inSpeedB": "Lihat pergerakan selagi ia masih penting.",
    "inSec": "Keselamatan",
    "inSecB": "Akaun anda. Keputusan anda.",
    "inRel": "Kebolehpercayaan",
    "inRelB": "AI tidak tamat syif.",
    "inTitle": "Log masuk",
    "inEmail": "E-mel",
    "inEmailErr": "Masukkan e-mel pada akaun anda.",
    "inPass": "Kata laluan",
    "inPassErr": "Masukkan kata laluan anda.",
    "inBusy": "Sedang log masuk…",
    "inNew": "Baru di sini?",
    "inCreate": "Cipta akaun",
    "inFail": "Tidak dapat log masuk.",
    "upKicker": "Buka akaun",
    "upH": "Daftar selagi pasaran terbuka.",
    "upP": "AI untuk kripto, saham dan emas. Kelajuan, keselamatan, dan bacaan yang kekal hidup.",
    "upTitle": "Daftar",
    "upH2": "Cipta akaun anda",
    "upName": "Nama penuh",
    "upNameErr": "Beritahu kami apa nama panggilan anda.",
    "upEmailErr": "Masukkan e-mel yang sah.",
    "upPhone": "Telefon",
    "upCode": "Kod negara",
    "upCodeShort": "Kod",
    "upCodePh": "Negara atau kod",
    "upNoCountry": "Tiada negara yang sepadan.",
    "upNumber": "Nombor",
    "upReal": "Masukkan nombor",
    "upReal2": "yang sebenar.",
    "upChooseCode": "Pilih kod negara, kemudian nombor.",
    "upCountry": "Negara",
    "upSelect": "Pilih negara",
    "upCountryErr": "Pilih negara anda.",
    "upPassErr": "Gunakan sekurang-kurangnya 8 aksara.",
    "upConfirm": "Sahkan kata laluan",
    "upMismatch": "Kata laluan itu tidak sepadan.",
    "upBusy": "Sedang dicipta…",
    "upCreate": "Cipta akaun",
    "detKicker": "Butiran peribadi",
    "detH": "Kami ingin mengenali anda dengan lebih baik",
    "detP": "Beberapa butiran, kemudian anda boleh membuka Deposit.",
    "detAddress": "Alamat",
    "detCity": "Bandar",
    "detZip": "Poskod",
    "detResidence": "Negara kediaman",
    "detNation": "Warganegara",
    "detBirth": "Tarikh lahir",
    "detBirthHint": "DD.MM.YYYY",
    "detBirthErr": "Masukkan tarikh yang sah sebagai DD.MM.YYYY.",
    "detEmpty": "Isi setiap ruangan.",
    "detProceed": "Teruskan",
    "detBusy": "Menyimpan…",
    "upAlready": "Sudah berdaftar?",
    "upFail": "Tidak dapat membuka akaun.",
    "trMissing": "Pasaran itu tiada pada AI.",
    "trMissingP": "CapiTrade menyimpan senarai pendek. Pilih nama lain dari pasaran.",
    "trBack": "Kembali ke pasaran",
    "trOpen": "Buka",
    "trHigh": "Tinggi",
    "trLow": "Rendah",
    "trVolume": "Volum",
    "trSession": "Sesi",
    "trCandles": "lilin",
    "trSide": "Sisi pesanan",
    "trBuy": "Beli",
    "trSell": "Jual",
    "trQty": "Kuantiti",
    "trFill": "Anggaran isi",
    "trNotional": "Nosional",
    "trCash": "Tunai",
    "trSending": "Menghantar…",
    "trWatchOff": "Buang dari senarai",
    "trWatchOn": "Tambah ke senarai",
    "trSign": "Log masuk untuk berdagang",
    "trNew": "Baru dengan AI?",
    "trOpenAcc": "Buka akaun",
    "trFine": "Pesanan pasaran. Diisi serta-merta pada sentuhan, ditambah spread 0.02%.",
    "trOpening": "Membuka pasaran…",
    "trWatchFail": "Tidak dapat mengemas kini senarai.",
    "trOrderFail": "Pesanan tidak diisi.",
    "trQtyZero": "Masukkan kuantiti lebih daripada sifar.",
    "trFilled": "Diisi {side} {qty} {symbol} pada {price}.",
    "trTicket": "Tiket",
    "pfKicker": "Profil",
    "pfP": "Butiran yang disimpan pada akaun ini.",
    "pfDetails": "Butiran profil",
    "pfName": "Nama",
    "pfEmail": "E-mel",
    "pfPhone": "Telefon",
    "pfCountry": "Negara",
    "pfCash": "Tunai",
    "pfMissing": "Tiada dalam rekod",
    "pfBack": "Kembali ke AI",
    "poDeposit": "Deposit",
    "poMarkets": "Pasaran",
    "poBot": "Bot AI",
    "poIq": "InvestIQ",
    "poGet": "Dapatkan bot",
    "poHelp": "Bantuan",
    "poProfile": "Profil",
    "poEquity": "Ekuiti",
    "poPnl": "P&L",
    "poWatch": "Senarai pantau",
    "poMovers": "Penggerak teratas",
    "poSell": "Jual",
    "poBuy": "Beli",
    "poEmpty": "Senarai pantau kosong.",
    "poChart": "Membuka carta…",
    "poSymbol": "Simbol",
    "poDay": "Hari",
    "poLast": "akhir",
    "poPositions": "Posisi terbuka",
    "poFills": "Isian terkini",
    "poNoPos": "Anda tidak mempunyai posisi terbuka.",
    "poNoPosB": "Beli dari senarai pantau dan posisi akan muncul di sini.",
    "poQty": "Kti",
    "poAvg": "Purata",
    "poNoFills": "Belum ada isian.",
    "poNoFillsB": "Pesanan pasaran muncul di sini sebaik sahaja diisi.",
    "poSide": "Sisi",
    "poPrice": "Harga",
    "poTime": "Masa",
    "poOpeningAcc": "Membuka akaun…",
    "poLoadFail": "Tidak dapat memuatkan akaun.",
    "poPay": "Bayaran kripto",
    "poConfirmed": "Setelah deposit anda disahkan dengan kami, kami akan mengesahkan bayaran anda dan menambahnya ke baki anda. Anda kemudian akan menerima bonus dan akses kepada ciri akaun anda.",
    "poChoose": "Pilih jenis akaun anda",
    "poAccounts": "Akaun",
    "poMin": "Deposit minimum",
    "poNext": "Seterusnya",
    "poGreat": "Pilihan yang baik",
    "poPeople": "orang memilih",
    "poStarted": "dan mula berdagang.",
    "poNetwork": "Pilih rangkaian anda",
    "poNetworks": "Rangkaian",
    "poBack": "Kembali",
    "poCopied": "Disalin",
    "poCopy": "Salin alamat",
    "poSendOnly": "Hantar hanya",
    "poOn": "pada rangkaian",
    "poNetworkWord": ".",
    "poAfter": "Selepas anda hantar, beritahu AI di Telegram.",
    "poLastPrice": "Harga akhir",
    "poStats": "Statistik",
    "poAnalysis": "Analisis",
    "poIndicators": "Penunjuk",
    "poTape": "Dibaca dari pita.",
    "poBotAlt": "Bot dagangan AI di meja skrin pasaran.",
    "poBotTitle": "Bot dagangan AI",
    "poBotP": "Bot kekal pada pita untuk anda. Ia mengikut trend, RSI dan purata bergerak, dan ia bekerja akaun semasa anda jauh dari skrin.",
    "poBotAccess": "Deposit akaun anda untuk mendapat akses kepada bot.",
    "poHelpTitle": "Bercakap dengan AI",
    "poHelpP": "Pilih satu soalan. Sembang menjawab, kemudian menawarkan langkah seterusnya. Ia tidak akan memberitahu anda apa yang perlu dibeli.",
    "poExplain": "Terangkan AI",
    "poReadM": "Baca satu pasaran",
    "poOpenMine": "Buka akaun saya",
    "askTitle": "Pembantu AI",
    "askSub": "Satu soalan pada satu masa. Bukan nasihat pelaburan.",
    "askStart": "Dari mana kita mula? Saya jawab satu langkah pada satu masa, dan saya tidak akan memberitahu anda apa yang perlu dibeli.",
    "askPh": "Atau taip soalan anda sendiri",
    "askSend": "Hantar",
    "askReplying": "AI sedang menjawab.",
    "askOffline": "Saya perlukan API pada port 8080 sebelum boleh menjawab. Mulakan, kemudian tanya lagi.",
    "lgHome": "Halaman utama",
    "lgPdf": "Buka dasar privasi (PDF)",
    "lgTermsT": "Terma perkhidmatan",
    "lgTerms1": "Terma ini menerangkan bagaimana meja latihan CapiTrade boleh digunakan. Terma operasi penuh akan diterbitkan di sini setelah nama syarikat yang sah, negara dan nombor pendaftaran disahkan.",
    "lgTerms2": "Kandungan laman web ini adalah maklumat umum sahaja. Ia bukan nasihat pelaburan, cadangan, atau tawaran untuk membeli atau menjual sebarang aset. Ia tidak mengambil kira objektif peribadi, keadaan kewangan atau keperluan anda.",
    "lgTerms3": "CapiTrade dikendalikan oleh CapiTrade, berdaftar di Afrika Selatan di bawah nombor 2021/630672/05.",
    "lgPrivT": "Dasar privasi",
    "lgPriv1": "Dasar privasi ialah PDF yang dipautkan di bawah. Ia merangkumi apa yang CapiTrade kumpul, mengapa, dan hak anda di bawah POPIA.",
    "lgCookT": "Dasar kuki",
    "lgCook1": "Laman ini menyimpan token log masuk dalam pelayar supaya akaun kekal terbuka. Ia tidak memaparkan sepanduk kuki pemasaran dan tidak menetapkan kuki iklan. Anda boleh memadam token dengan log keluar, atau dengan memadam data laman ini dalam pelayar.",
    "lgAmlT": "Dasar AML",
    "lgAml1": "Deposit yang disahkan disemak sebelum ditambah ke baki. Dasar anti pengubahan wang haram yang penuh akan diterbitkan di sini setelah nama syarikat yang sah, negara dan nombor pendaftaran disahkan.",
    "lgRiskT": "Pendedahan risiko",
    "lgRisk1": "Berdagang mata wang kripto dan instrumen kewangan lain melibatkan risiko tinggi dan anda boleh kehilangan sebahagian modal. Prestasi lalu, termasuk hasil strategi automatik atau berasaskan AI, tidak menjamin hasil akan datang. Berdagang hanya dengan wang yang anda mampu kehilangan.",
    "lgRisk2": "Kandungan laman web ini adalah maklumat umum sahaja. Ia bukan cadangan, atau tawaran untuk membeli atau menjual sebarang aset. Ia tidak mengambil kira objektif peribadi, keadaan kewangan atau keperluan anda. Sebelum berdagang, pastikan produk yang ditawarkan sesuai dengan matlamat dan toleransi risiko anda, dan dapatkan nasihat bebas jika perlu.",
    "iqNoCandles": "Pita belum mempunyai 14 lilin, jadi RSI, MACD dan purata tidak dapat dikira.",
    "iqRsiLine": "RSI (14) {symbol} ialah {rsi}{shift}. {note}",
    "iqShiftUp": ", naik dari {prior} tiga lilin lalu",
    "iqShiftDown": ", turun dari {prior} tiga lilin lalu",
    "iqShiftFlat": ", hampir tidak berubah dari {prior} tiga lilin lalu",
    "iqRsiHigh": "Bacaan di atas 70 bermaksud 14 lilin terakhir naik jauh lebih laju daripada ia jatuh.",
    "iqRsiLow": "Bacaan di bawah 30 bermaksud 14 lilin terakhir jatuh jauh lebih laju daripada ia naik.",
    "iqRsiMid": "Itu tengah skala 0 hingga 100, jadi kenaikan dan kejatuhan terkini adalah hampir.",
    "iqMacdLine": "MACD ialah {line}, {side} isyaratnya pada {signal}, dan {hist}.",
    "iqAbove": "di atas",
    "iqBelow": "di bawah",
    "iqHistPosWide": "histogram positif dan melebar",
    "iqHistPosNarrow": "histogram positif dan mengecil",
    "iqHistNegWide": "histogram negatif dan melebar",
    "iqHistNegNarrow": "histogram negatif dan mengecil",
    "iqHistPos": "histogram positif",
    "iqHistNeg": "histogram negatif",
    "iqHistFlat": "histogram rata",
    "iqPrice20": "Harga {side} purata 20 tempoh pada {price}.",
    "iqPrice2050": "Harga {a} purata 20 tempoh pada {p20} dan {b} purata 50 tempoh pada {p50}.",
    "iqBandUp": "Harga di luar jalur Bollinger atas pada {price}.",
    "iqBandDown": "Harga di luar jalur Bollinger bawah pada {price}.",
    "iqBandIn": "Harga di dalam jalur Bollinger, {low} hingga {high}.",
    "iqStochTop": "Stokastik %K ialah {value}, hampir puncak julat 14 lilinnya.",
    "iqStochBot": "Stokastik %K ialah {value}, hampir dasar julat 14 lilinnya.",
    "iqStoch": "Stokastik %K ialah {value}.",
    "iqAtrLine": "Julat benar purata (14) ialah {range}.",
    "iqSession": "Pada sesi, harga {above} di atas rendah dan {under} di bawah tinggi, {pct}% melalui julat.",
    "iqSelect": "Pilih simbol untuk membaca sesi.",
    "iqPlace": "Cetakan terakhir ialah {pct}% perjalanan dari rendah sesi {low} ke tinggi sesi {high}.",
    "iqStretched": "Tegang",
    "iqWashed": "Lesu",
    "iqFirm": "Kukuh",
    "iqSoft": "Lembut",
    "iqNeutral": "Neutral",
    "iqRsiName": "RSI (14)",
    "iqMacdName": "MACD (12, 26)",
    "iqSignalName": "Isyarat (9)",
    "iqHistName": "Histogram",
    "iqSma20Name": "SMA 20",
    "iqSma50Name": "SMA 50",
    "iqBollUpName": "Bollinger atas",
    "iqBollLoName": "Bollinger bawah",
    "iqStochName": "Stokastik %K",
    "iqAtrName": "ATR (14)",
    "iqMacdNote": "Purata pantas tolak purata perlahan",
    "iqSignalNote": "Purata 9 tempoh MACD",
    "iqBollUpNote": "Purata 20 tempoh tambah 2 sisihan",
    "iqBollLoNote": "Purata 20 tempoh tolak 2 sisihan",
    "iqAtrNote": "Julat benar purata 14 lilin terakhir",
    "iqNeeds15": "Perlu 15 penutupan",
    "iqNeeds35": "Perlu 35 penutupan",
    "iqNeeds14": "Perlu 14 lilin",
    "iqNeedsMore": "Perlu lebih banyak lilin untuk {label}",
    "iqAboveLabel": "Harga di atas {label}",
    "iqBelowLabel": "Harga di bawah {label}",
    "iqRsiStretchNote": "Tegang, di atas 70",
    "iqRsiWashNote": "Lesu, di bawah 30",
    "iqRsiMidNote": "Tengah skala",
    "iqStochTopNote": "Hampir puncak julat",
    "iqStochBotNote": "Hampir dasar julat",
    "iqStochMidNote": "Hampir tinggi dan rendah 14 lilin",
    "iqAvg20": "purata 20 tempoh",
    "iqAvg50": "purata 50 tempoh",
    "trustOpening": "Membuka Trust Wallet pada halaman ini…",
    "trustConnected": "Trust Wallet terbuka. Alamat anda pada halaman ini:",
    "trustMissing": "Trust Wallet tidak dipasang dalam pelayar ini. Tambah sambungan Trust Wallet, kemudian buka semula dari sini. Ia kekal pada halaman deposit ini.",
    "trustClosed": "Trust Wallet ditutup.",
    "trustRetry": "Buka Trust Wallet",
    "trustDownload": "Dapatkan Trust Wallet"
  },
  es: {
    "menu": "Menú",
    "close": "Cerrar",
    "signOut": "Cerrar sesión",
    "account": "Cuenta",
    "noMatch": "Ningún símbolo coincide.",
    "jump": "Ir a un símbolo",
    "tradingAccounts": "Cuentas de trading",
    "navProducts": "Productos",
    "navEquities": "Acciones",
    "navEquitiesSub": "Acciones de la lista de la mañana.",
    "navIndexes": "Índices",
    "navIndexesSub": "SPY y QQQ.",
    "navCrypto": "Cripto",
    "navCryptoSub": "Bitcoin y ether.",
    "navFx": "Divisas",
    "navFxSub": "El par euro-dólar.",
    "navMetals": "Metales",
    "navMetalsSub": "Oro, cotizado como XAUUSD.",
    "navAi": "IA",
    "navAll": "Todos los mercados",
    "navAllSub": "La lista completa.",
    "navPractice": "Una orden de práctica",
    "navPracticeSub": "Elija un nombre y envíe el ticket.",
    "navPlatform": "Plataforma",
    "navRead": "Lectura de la IA",
    "navReadSub": "La IA nombra un líder. Usted envía la orden.",
    "navYours": "Su cuenta",
    "navYoursIn": "Nombre, correo y el saldo de práctica.",
    "navYoursOut": "Una cuenta de práctica con fondos.",
    "navAcc": "Cuentas",
    "navOverview": "Resumen de cuentas",
    "navOverviewSub": "De 250 $ a 100.000 $.",
    "navPortSub": "Efectivo, posiciones y órdenes.",
    "navOpenSub": "El saldo empieza en 0 $.",
    "navSignSub": "Volver a la IA.",
    "navFourSub": "Del registro a la primera orden.",
    "navListSub": "Una lista corta, a propósito.",
    "navSupportSub": "Soporte mundial desde la IA.",
    "navAiSub": "Para qué está hecho CapiTrade.",
    "navClientsSub": "Lo que dicen después de una sesión.",
    "navTelegram": "Telegram.",
    "navTheRead": "La lectura",
    "navTheReadSub": "La IA observa. Usted envía la orden.",
    "navHowStarts": "Cómo empieza",
    "navHowStartsSub": "Abra la cuenta y luego elija un mercado.",
    "footBlurb": "Herramientas de trading asistidas por IA para cripto y mercados globales.",
    "footRisk": "Advertencia de riesgo. Operar con criptomonedas y otros instrumentos financieros implica un alto nivel de riesgo y puede perder parte de su capital. Los resultados pasados, incluidos los de estrategias automáticas o basadas en IA, no garantizan resultados futuros. Opere solo con dinero que pueda permitirse perder.",
    "footRiskLink": "Lea la advertencia de riesgo completa.",
    "footInfo": "El contenido de este sitio es solo información general. No es una recomendación ni una oferta de compra o venta de ningún activo. No tiene en cuenta sus objetivos personales, su situación financiera ni sus necesidades. Antes de operar, compruebe que los productos ofrecidos encajan con sus metas y su tolerancia al riesgo, y busque asesoramiento independiente si lo necesita.",
    "footOperator": "CapiTrade es operado por CapiTrade, registrado en Sudáfrica con el número 2021/630672/05. Domicilio social: First Floor Kgabo Mashego, Eremomela Avenue, 1749, Sudáfrica. CapiTrade solo ofrece herramientas de software. No presta asesoramiento de inversión y no custodia fondos de clientes. Este sitio no se dirige a residentes de ninguna jurisdicción donde su uso sea contrario a la ley o la normativa local.",
    "footRights": "Todos los derechos reservados.",
    "footTerms": "Condiciones del servicio",
    "footPrivacy": "Política de privacidad",
    "footCookies": "Política de cookies",
    "footAml": "Política AML",
    "footRiskName": "Advertencia de riesgo",
    "footHours": "De lunes a viernes, de 9:00 a 18:00",
    "footPolicies": "Políticas",
    "docTitle": "CapiTrade — trading con IA",
    "homeWelcome1": "Abra el mundo del",
    "homeWelcome2": "trading con",
    "homeWelcome3": "IA.",
    "homeH1": "Plataforma de trading",
    "homeH1em": "totalmente automática.",
    "homeLede": "Agentes de trading con IA, con velocidad, seguridad y fiabilidad.",
    "homeTrade": "Operar ahora",
    "homeDeposit": "Primer depósito",
    "homeLicensed": "® Con licencia y regulado",
    "homeAltScreen": "Una pantalla oscura de trading con IA y un gráfico dorado en el monitor.",
    "homeAltTrader": "Una operadora sonriendo ante una cotización en su teléfono.",
    "homeEdge": "El mercado cripto no duerme, y su ventaja tampoco.",
    "homeP1": "Bitcoin y el resto del mercado se mueven ahora mismo. Cada minuto nace un nuevo impulso, aparecen nuevos líderes y surgen y desaparecen oportunidades. Nuestro bot de trading con IA recorre los mercados cripto sin parar, lee precio, volumen e impulso en decenas de activos y nombra a los candidatos más fuertes para que usted no tenga que perseguirlos.",
    "homeP2": "Usted sigue al mando. El bot observa, ordena y señala. Usted decide y envía la orden. Nunca opera por usted.",
    "homeWhy": "Por qué lo eligen los operadores",
    "homeSpeed": "Velocidad",
    "homeSpeedBody": "Las señales se actualizan en tiempo real, así que ve el movimiento mientras aún importa.",
    "homeSecurity": "Seguridad",
    "homeSecurityBody": "Sus decisiones, su cuenta, sus fondos. El bot nunca tiene las llaves.",
    "homeReliable": "Fiabilidad",
    "homeReliableBody": "Sin cansancio, sin distracciones, sin alertas perdidas. Trabaja el mercado mientras usted vive su vida.",
    "homeRegister": "El mercado no va a frenar por nadie. Regístrese hoy y ponga un analista de IA de su lado mientras la oportunidad sigue ahí.",
    "homePlaying": "Reproduciendo",
    "homeFilm": "Película de IA · 00:18",
    "homeQuiet": "una operación más tranquila",
    "homeMorning": "Mercado de la mañana",
    "homeLive": "En vivo",
    "homeOffline": "El mercado está fuera de línea. Arranque la API en el puerto 8080.",
    "homeOpening": "Abriendo el mercado…",
    "homeTradeNvda": "Operar NVIDIA",
    "homeDepKicker": "Haga que su primer depósito cripto cuente",
    "homeDepH": "Haga que su primer depósito cripto",
    "homeDepEm": "cuente.",
    "homeDepP": "Fondee su cuenta con cripto por primera vez y reciba un bono de bienvenida de hasta el 50 % en su primer depósito. Después, deje que nuestro bot de trading con IA trabaje el mercado por usted.",
    "homeHow": "Cómo funciona",
    "homeLi1": "Regístrese",
    "homeLi1b": "y abra su cuenta en minutos.",
    "homeLi2": "Deposite cripto",
    "homeLi2b": "(BTC, ETH, USDT y más) por primera vez.",
    "homeLi3": "Reciba su bono",
    "homeLi3b": "y acceda a su propio bot de trading con IA.",
    "homeLi4": "Deje que el bot gestione su cuenta",
    "homeLi4b": ", recorriendo el mercado sin parar y actuando ante las oportunidades, para que usted no tenga que mirar cada movimiento.",
    "homeFine": "Oferta solo para usuarios nuevos. Se aplica un depósito mínimo de 250 $. El bono está sujeto a requisitos de volumen de trading. Operar cripto implica un alto riesgo de pérdida. Nuestro bot de trading con IA y las herramientas de cartera aplican técnicas de gestión del riesgo, como el tamaño de la posición y reglas de stop, para ayudarle a mantener la disciplina en mercados volátiles.",
    "homeSupport": "Soporte mundial",
    "homeGlobal": "Servicio global",
    "homeAssist": "Asistencia 24/7",
    "homeAccess": "Acceso a mercados de todo el mundo",
    "homeMulti": "Soporte multilingüe",
    "homeLiveRead": "Lectura en vivo",
    "homeFocusA": "Quédese con el nombre que puede explicar.",
    "homeFocusB": "lidera el mercado en vivo en",
    "homePaceA": "mercados están al alza. No los necesita todos. Elija uno y deje el resto en el mercado.",
    "homePaceOf": "de",
    "homeNerveA": "es la impresión pesada en",
    "homeNerveB": "Mida la operación antes de perseguir la sensación.",
    "homeAnother": "Otra lectura",
    "homeWait": "La IA espera la primera impresión. Arranque la API y la lectura seguirá al mercado.",
    "homeAsk": "Preguntar a la IA",
    "homeReadPrices": "Lectura de precios en vivo.",
    "homeM1": "Regístrese mientras el mercado sigue en demanda.",
    "homeM2": "Deje que la IA nombre al líder.",
    "homeM3": "El primer depósito es efectivo de práctica. Luego envíe la orden.",
    "homeClients": "Clientes",
    "homeReviews": "Lo que dicen después de la primera sesión.",
    "homeStars": "5 estrellas",
    "homeR1t": "Cripto",
    "homeR1": "Deposité, recibí mi bono y tuve el bot en marcha el mismo día. La puesta en marcha tardó minutos y fue fácil de seguir.",
    "homeR2t": "Acciones",
    "homeR2": "Antes me quedaba mirando gráficos todo el día. Ahora el bot vigila el mercado sin parar y yo miro cuando me conviene.",
    "homeR3t": "Oro y bitcoin",
    "homeR3": "Lo que me gusta es la disciplina. El bot sigue sus reglas de riesgo incluso cuando yo habría entrado en pánico.",
    "homeMarkets": "Mercados",
    "homeShort": "Una lista corta, a propósito.",
    "homeAll": "Todos los mercados",
    "homeThMarket": "Mercado",
    "homeThSession": "Sesión",
    "homeThLast": "Último",
    "homeThChange": "Cambio",
    "homeEmpty": "Esperando la primera impresión.",
    "homeFourK": "Empiece en cuatro pasos",
    "homeFourH": "Del registro a su primera operación con IA en minutos.",
    "homeS1": "Abrir una cuenta",
    "homeS1b": "Cree su cuenta. Escriba su nombre, su correo y una contraseña. La verificación tarda solo unos minutos.",
    "homeS2": "Elegir un mercado",
    "homeS2b": "Haga su primer depósito. Fondee su cuenta con BTC, ETH, USDT u otra cripto admitida (mínimo 250 $) y reclame su bono de bienvenida de hasta el 50 %.",
    "homeS3": "Enviar una orden a mercado",
    "homeS3b": "Active su bot de trading con IA. Elija sus mercados y sus ajustes de riesgo, y el bot empieza a recorrer el mercado sin parar.",
    "homeS4": "Revisar la cuenta",
    "homeS4b": "Siga todo en vivo. Su saldo, su patrimonio y su ganancia y pérdida se actualizan en tiempo real. Ajuste sus parámetros o retire cuando quiera, sujeto a las condiciones del bono.",
    "homeNow": "Regístrese ahora",
    "homePartners": "Alianzas",
    "homeCloseH": "La impresión más fuerte no esperará",
    "homeCloseEm": "una cuenta vacía.",
    "homeCloseP": "Abra su cuenta hoy, haga su primer depósito cripto de 250 $ o más y reciba un bono de bienvenida de hasta el 50 %. Su bot de trading con IA se pone a trabajar enseguida.",
    "mktKicker": "Mercado",
    "mktTitle": "Mercados",
    "mktLede": "Quince nombres. Busque, filtre y abra un ticket.",
    "mktSearch": "Buscar mercados",
    "mktPh": "Símbolo o nombre",
    "mktClass": "Clase de activo",
    "mktMarket": "Mercado",
    "mktClassCol": "Clase",
    "mktTrend": "Tendencia",
    "mktLast": "Último",
    "mktChange": "Cambio",
    "mktVolume": "Volumen",
    "mktOffline": "La IA está fuera de línea. Arranque la API y actualice.",
    "mktOpening": "Abriendo el mercado…",
    "mktNone": "Nada coincide con esa búsqueda.",
    "classALL": "Todo",
    "classEQUITY": "Acciones",
    "classINDEX": "Índices",
    "classCRYPTO": "Cripto",
    "classFX": "Divisas",
    "classCOMMODITY": "Metales",
    "oneEQUITY": "Acción",
    "oneINDEX": "Índice",
    "oneCRYPTO": "Cripto",
    "oneFX": "Divisas",
    "oneCOMMODITY": "Metal",
    "accTitle": "Cuentas",
    "accPort": "Su cartera",
    "accOpen": "Abrir una cuenta",
    "accRange": "De 250 $ a 100.000 $.",
    "accFrom": "Desde",
    "accClassic": "Cuenta Classic",
    "accClassicLine": "Acceso sencillo. Una primera mirada al mercado, con ayuda cuando la pida.",
    "accSilver": "Cuenta Silver",
    "accSilverLine": "Más exposición al mercado, un bot de trading, soporte 24/7 y 1 gestor de cuenta si lo pide.",
    "accGold": "Cuenta Gold",
    "accGoldLine": "Mayor exposición al mercado, más bots de trading, soporte 24/7 y 2 gestores de cuenta si lo pide.",
    "accPlat": "Cuenta Platinum",
    "accPlatLine": "Exposición profunda al mercado, un conjunto más fuerte de bots, soporte prioritario 24/7 y 3 gestores de cuenta.",
    "accVip": "Cuenta VIP",
    "accVipLine": "Acceso completo a un asesor financiero y de 1 a 5 gestores de cuenta, con todos los bots y la exposición más amplia.",
    "inKicker": "Su cuenta",
    "inH": "El mercado no espera.",
    "inP": "Vuelva a cripto, acciones y oro. Velocidad, seguridad y una lectura que siguió encendida.",
    "inSpeed": "Velocidad",
    "inSpeedB": "Vea el movimiento mientras aún importa.",
    "inSec": "Seguridad",
    "inSecB": "Su cuenta. Sus decisiones.",
    "inRel": "Fiabilidad",
    "inRelB": "La IA no ficha la salida.",
    "inTitle": "Entrar",
    "inEmail": "Correo",
    "inEmailErr": "Escriba el correo de su cuenta.",
    "inPass": "Contraseña",
    "inPassErr": "Escriba su contraseña.",
    "inBusy": "Entrando…",
    "inNew": "¿Nuevo aquí?",
    "inCreate": "Crear una cuenta",
    "inFail": "No se pudo entrar.",
    "upKicker": "Abrir una cuenta",
    "upH": "Regístrese mientras el mercado está abierto.",
    "upP": "Una IA para cripto, acciones y oro. Velocidad, seguridad y una lectura que sigue encendida.",
    "upTitle": "Registro",
    "upH2": "Cree su cuenta",
    "upName": "Nombre completo",
    "upNameErr": "Díganos cómo llamarle.",
    "upEmailErr": "Escriba un correo válido.",
    "upPhone": "Teléfono",
    "upCode": "Prefijo del país",
    "upCodeShort": "Código",
    "upCodePh": "País o prefijo",
    "upNoCountry": "Ningún país coincide.",
    "upNumber": "Número",
    "upReal": "Escriba un número real de",
    "upReal2": ".",
    "upChooseCode": "Elija el prefijo y luego el número.",
    "upCountry": "País",
    "upSelect": "Elija un país",
    "upCountryErr": "Elija su país.",
    "upPassErr": "Use al menos 8 caracteres.",
    "upConfirm": "Confirmar contraseña",
    "upMismatch": "Esas contraseñas no coinciden.",
    "upBusy": "Creando…",
    "upCreate": "Crear cuenta",
    "detKicker": "Datos personales",
    "detH": "Queremos conocerle mejor",
    "detP": "Unos datos y después puede abrir Depósito.",
    "detAddress": "Dirección",
    "detCity": "Ciudad",
    "detZip": "Código postal",
    "detResidence": "País de residencia",
    "detNation": "Nacionalidad",
    "detBirth": "Fecha de nacimiento",
    "detBirthHint": "DD.MM.AAAA",
    "detBirthErr": "Escriba una fecha real como DD.MM.AAAA.",
    "detEmpty": "Rellene todos los campos.",
    "detProceed": "Continuar",
    "detBusy": "Guardando…",
    "upAlready": "¿Ya está registrado?",
    "upFail": "No se pudo abrir la cuenta.",
    "trMissing": "Ese mercado no está en la IA.",
    "trMissingP": "CapiTrade mantiene una lista corta. Elija otro nombre del mercado.",
    "trBack": "Volver a los mercados",
    "trOpen": "Apertura",
    "trHigh": "Máximo",
    "trLow": "Mínimo",
    "trVolume": "Volumen",
    "trSession": "Sesión",
    "trCandles": "velas",
    "trSide": "Lado de la orden",
    "trBuy": "Comprar",
    "trSell": "Vender",
    "trQty": "Cantidad",
    "trFill": "Ejecución est.",
    "trNotional": "Nominal",
    "trCash": "Efectivo",
    "trSending": "Enviando…",
    "trWatchOff": "Quitar de la lista",
    "trWatchOn": "Añadir a la lista",
    "trSign": "Entre para operar",
    "trNew": "¿Nuevo en la IA?",
    "trOpenAcc": "Abrir cuenta",
    "trFine": "Orden a mercado. Se ejecuta al momento en el toque, más un diferencial del 0,02 %.",
    "trOpening": "Abriendo el mercado…",
    "trWatchFail": "No se pudo actualizar la lista.",
    "trOrderFail": "La orden no se ejecutó.",
    "trQtyZero": "Escriba una cantidad mayor que cero.",
    "trFilled": "Ejecutado {side} {qty} {symbol} a {price}.",
    "trTicket": "Ticket",
    "pfKicker": "Perfil",
    "pfP": "Los datos guardados en esta cuenta.",
    "pfDetails": "Datos del perfil",
    "pfName": "Nombre",
    "pfEmail": "Correo",
    "pfPhone": "Teléfono",
    "pfCountry": "País",
    "pfCash": "Efectivo",
    "pfMissing": "No consta",
    "pfBack": "Volver a la IA",
    "poDeposit": "Depósito",
    "poMarkets": "Mercados",
    "poBot": "Bot de IA",
    "poIq": "InvestIQ",
    "poGet": "Obtener el bot",
    "poHelp": "Ayuda",
    "poProfile": "Perfil",
    "poEquity": "Patrimonio",
    "poPnl": "P&L",
    "poWatch": "Lista de seguimiento",
    "poMovers": "Mayores movimientos",
    "poSell": "Vender",
    "poBuy": "Comprar",
    "poEmpty": "La lista de seguimiento está vacía.",
    "poChart": "Abriendo el gráfico…",
    "poSymbol": "Símbolo",
    "poDay": "Día",
    "poLast": "último",
    "poPositions": "Posiciones abiertas",
    "poFills": "Ejecuciones recientes",
    "poNoPos": "No tiene posiciones abiertas.",
    "poNoPosB": "Compre desde la lista y la posición aparece aquí.",
    "poQty": "Cant.",
    "poAvg": "Med.",
    "poNoFills": "Aún no hay ejecuciones.",
    "poNoFillsB": "Una orden a mercado aparece aquí en cuanto se ejecuta.",
    "poSide": "Lado",
    "poPrice": "Precio",
    "poTime": "Hora",
    "poOpeningAcc": "Abriendo la cuenta…",
    "poLoadFail": "No se pudo cargar la cuenta.",
    "poPay": "Pago en cripto",
    "poConfirmed": "Cuando su depósito quede confirmado con nosotros, verificaremos el pago y lo añadiremos a su saldo. Después recibirá su bono y el acceso a las funciones de su cuenta.",
    "poChoose": "Elija su tipo de cuenta",
    "poAccounts": "Cuentas",
    "poMin": "Depósito mínimo",
    "poNext": "Siguiente",
    "poGreat": "Buena elección",
    "poPeople": "personas eligieron",
    "poStarted": "y empezaron a operar.",
    "poNetwork": "Elija su red",
    "poNetworks": "Redes",
    "poBack": "Atrás",
    "poCopied": "Copiado",
    "poCopy": "Copiar dirección",
    "poSendOnly": "Envíe solo",
    "poOn": "en la red",
    "poNetworkWord": ".",
    "poAfter": "Después de enviarlo, avise a la IA en Telegram.",
    "poLastPrice": "Último precio",
    "poStats": "Estadísticas",
    "poAnalysis": "Análisis",
    "poIndicators": "Indicadores",
    "poTape": "Leído de la cinta.",
    "poBotAlt": "Un bot de trading con IA frente a pantallas de mercado.",
    "poBotTitle": "Bot de trading con IA",
    "poBotP": "El bot se queda en la cinta por usted. Sigue la tendencia, el RSI y las medias móviles, y trabaja la cuenta mientras usted no está frente a la pantalla.",
    "poBotAccess": "Deposite en su cuenta para acceder al bot.",
    "poHelpTitle": "Hablar con la IA",
    "poHelpP": "Elija una pregunta. El chat responde y luego ofrece el siguiente paso. No le dirá qué comprar.",
    "poExplain": "Explicar la IA",
    "poReadM": "Leer un mercado",
    "poOpenMine": "Abrir mi cuenta",
    "askTitle": "Asistente de IA",
    "askSub": "Una pregunta cada vez. No es asesoramiento de inversión.",
    "askStart": "¿Por dónde empezamos? Respondo un paso cada vez y no le diré qué comprar.",
    "askPh": "O escriba su propia pregunta",
    "askSend": "Enviar",
    "askReplying": "La IA está respondiendo.",
    "askOffline": "Necesito la API en el puerto 8080 antes de poder responder. Arránquela y vuelva a preguntar.",
    "lgHome": "Página de inicio",
    "lgPdf": "Abrir la política de privacidad (PDF)",
    "lgTermsT": "Condiciones del servicio",
    "lgTerms1": "Estas condiciones describen cómo se puede usar el escritorio de práctica de CapiTrade. Las condiciones operativas completas se publicarán aquí cuando se confirmen el nombre legal, el país y el número de registro.",
    "lgTerms2": "El contenido de este sitio es solo información general. No es asesoramiento de inversión, ni una recomendación, ni una oferta de compra o venta de ningún activo. No tiene en cuenta sus objetivos personales, su situación financiera ni sus necesidades.",
    "lgTerms3": "CapiTrade es operado por CapiTrade, registrado en Sudáfrica con el número 2021/630672/05.",
    "lgPrivT": "Política de privacidad",
    "lgPriv1": "La política de privacidad es el PDF enlazado abajo. Cubre lo que CapiTrade recoge, por qué y los derechos que tiene según la POPIA.",
    "lgCookT": "Política de cookies",
    "lgCook1": "El sitio guarda un token de sesión en el navegador para que la cuenta siga abierta. No muestra un aviso de cookies de marketing y no pone cookies de publicidad. Puede borrar el token al cerrar sesión o al borrar los datos de este sitio en su navegador.",
    "lgAmlT": "Política AML",
    "lgAml1": "Un depósito confirmado se revisa antes de añadirse a un saldo. La política completa contra el blanqueo se publicará aquí cuando se confirmen el nombre legal, el país y el número de registro.",
    "lgRiskT": "Advertencia de riesgo",
    "lgRisk1": "Operar con criptomonedas y otros instrumentos financieros implica un alto nivel de riesgo y puede perder parte de su capital. Los resultados pasados, incluidos los de estrategias automáticas o basadas en IA, no garantizan resultados futuros. Opere solo con dinero que pueda permitirse perder.",
    "lgRisk2": "El contenido de este sitio es solo información general. No es una recomendación ni una oferta de compra o venta de ningún activo. No tiene en cuenta sus objetivos personales, su situación financiera ni sus necesidades. Antes de operar, compruebe que los productos ofrecidos encajan con sus metas y su tolerancia al riesgo, y busque asesoramiento independiente si lo necesita.",
    "iqNoCandles": "La cinta aún no tiene 14 velas, así que el RSI, el MACD y las medias no se pueden calcular.",
    "iqRsiLine": "El RSI (14) de {symbol} está en {rsi}{shift}. {note}",
    "iqShiftUp": ", por encima de {prior} hace tres velas",
    "iqShiftDown": ", por debajo de {prior} hace tres velas",
    "iqShiftFlat": ", casi igual que {prior} hace tres velas",
    "iqRsiHigh": "Una lectura por encima de 70 significa que las últimas 14 velas subieron mucho más rápido de lo que bajaron.",
    "iqRsiLow": "Una lectura por debajo de 30 significa que las últimas 14 velas bajaron mucho más rápido de lo que subieron.",
    "iqRsiMid": "Es el centro de la escala de 0 a 100, así que las subidas y bajadas recientes están cerca.",
    "iqMacdLine": "El MACD está en {line}, {side} su señal en {signal}, y {hist}.",
    "iqAbove": "por encima de",
    "iqBelow": "por debajo de",
    "iqHistPosWide": "el histograma es positivo y se ensancha",
    "iqHistPosNarrow": "el histograma es positivo y se estrecha",
    "iqHistNegWide": "el histograma es negativo y se ensancha",
    "iqHistNegNarrow": "el histograma es negativo y se estrecha",
    "iqHistPos": "el histograma es positivo",
    "iqHistNeg": "el histograma es negativo",
    "iqHistFlat": "el histograma está plano",
    "iqPrice20": "El precio está {side} la media de 20 periodos en {price}.",
    "iqPrice2050": "El precio está {a} la media de 20 periodos en {p20} y {b} la media de 50 periodos en {p50}.",
    "iqBandUp": "El precio está fuera de la banda de Bollinger superior en {price}.",
    "iqBandDown": "El precio está fuera de la banda de Bollinger inferior en {price}.",
    "iqBandIn": "El precio está dentro de las bandas de Bollinger, de {low} a {high}.",
    "iqStochTop": "El estocástico %K está en {value}, cerca del techo de su rango de 14 velas.",
    "iqStochBot": "El estocástico %K está en {value}, cerca del suelo de su rango de 14 velas.",
    "iqStoch": "El estocástico %K está en {value}.",
    "iqAtrLine": "El rango verdadero medio (14) es {range}.",
    "iqSession": "En la sesión, el precio está {above} por encima del mínimo y {under} por debajo del máximo, al {pct} % del rango.",
    "iqSelect": "Elija un símbolo para leer la sesión.",
    "iqPlace": "La última impresión está al {pct} % del camino entre el mínimo de sesión {low} y el máximo de sesión {high}.",
    "iqStretched": "Estirado",
    "iqWashed": "Lavado",
    "iqFirm": "Firme",
    "iqSoft": "Blando",
    "iqNeutral": "Neutral",
    "iqRsiName": "RSI (14)",
    "iqMacdName": "MACD (12, 26)",
    "iqSignalName": "Señal (9)",
    "iqHistName": "Histograma",
    "iqSma20Name": "SMA 20",
    "iqSma50Name": "SMA 50",
    "iqBollUpName": "Bollinger superior",
    "iqBollLoName": "Bollinger inferior",
    "iqStochName": "Estocástico %K",
    "iqAtrName": "ATR (14)",
    "iqMacdNote": "Media rápida menos media lenta",
    "iqSignalNote": "Media de 9 periodos del MACD",
    "iqBollUpNote": "Media de 20 periodos más 2 desviaciones",
    "iqBollLoNote": "Media de 20 periodos menos 2 desviaciones",
    "iqAtrNote": "Rango verdadero medio de las últimas 14 velas",
    "iqNeeds15": "Hacen falta 15 cierres",
    "iqNeeds35": "Hacen falta 35 cierres",
    "iqNeeds14": "Hacen falta 14 velas",
    "iqNeedsMore": "Hacen falta más velas para {label}",
    "iqAboveLabel": "El precio está por encima de {label}",
    "iqBelowLabel": "El precio está por debajo de {label}",
    "iqRsiStretchNote": "Estirado, por encima de 70",
    "iqRsiWashNote": "Lavado, por debajo de 30",
    "iqRsiMidNote": "Centro de la escala",
    "iqStochTopNote": "Cerca del techo del rango",
    "iqStochBotNote": "Cerca del suelo del rango",
    "iqStochMidNote": "Cerca del máximo y el mínimo de 14 velas",
    "iqAvg20": "la media de 20 periodos",
    "iqAvg50": "la media de 50 periodos",
    "trustOpening": "Abriendo Trust Wallet en esta página…",
    "trustConnected": "Trust Wallet está abierto. Su dirección en esta página:",
    "trustMissing": "Trust Wallet no está instalado en este navegador. Añada la extensión Trust Wallet y ábrala de nuevo desde aquí. Se queda en esta página de depósito.",
    "trustClosed": "Trust Wallet se cerró.",
    "trustRetry": "Abrir Trust Wallet",
    "trustDownload": "Obtener Trust Wallet"
  },
  de: {
    "menu": "Menü",
    "close": "Schließen",
    "signOut": "Abmelden",
    "account": "Konto",
    "noMatch": "Kein Symbol passt.",
    "jump": "Zu einem Symbol springen",
    "tradingAccounts": "Handelskonten",
    "navProducts": "Produkte",
    "navEquities": "Aktien",
    "navEquitiesSub": "Aktien auf der Morgenliste.",
    "navIndexes": "Indizes",
    "navIndexesSub": "SPY und QQQ.",
    "navCrypto": "Krypto",
    "navCryptoSub": "Bitcoin und Ether.",
    "navFx": "Devisen",
    "navFxSub": "Das Euro-Dollar-Paar.",
    "navMetals": "Metalle",
    "navMetalsSub": "Gold, notiert als XAUUSD.",
    "navAi": "KI",
    "navAll": "Alle Märkte",
    "navAllSub": "Die volle Liste.",
    "navPractice": "Ein Übungsauftrag",
    "navPracticeSub": "Wählen Sie einen Namen und senden Sie das Ticket.",
    "navPlatform": "Plattform",
    "navRead": "KI-Lesung",
    "navReadSub": "Die KI nennt einen Führenden. Sie senden den Auftrag.",
    "navYours": "Ihr Konto",
    "navYoursIn": "Name, E-Mail und das Übungsguthaben.",
    "navYoursOut": "Ein finanziertes Übungskonto.",
    "navAcc": "Konten",
    "navOverview": "Kontenübersicht",
    "navOverviewSub": "Von 250 $ bis 100.000 $.",
    "navPortSub": "Bargeld, Positionen und Aufträge.",
    "navOpenSub": "Das Guthaben beginnt bei 0 $.",
    "navSignSub": "Zurück zur KI.",
    "navFourSub": "Von der Anmeldung zum ersten Auftrag.",
    "navListSub": "Eine kurze Liste, mit Absicht.",
    "navSupportSub": "Weltweiter Support über die KI.",
    "navAiSub": "Wofür CapiTrade gebaut ist.",
    "navClientsSub": "Was sie nach einer Sitzung sagen.",
    "navTelegram": "Telegram.",
    "navTheRead": "Die Lesung",
    "navTheReadSub": "Die KI beobachtet. Sie senden den Auftrag.",
    "navHowStarts": "So beginnt es",
    "navHowStartsSub": "Öffnen Sie das Konto und wählen Sie dann einen Markt.",
    "footBlurb": "KI-gestützte Handelstools für Krypto und globale Märkte.",
    "footRisk": "Risikohinweis. Der Handel mit Kryptowährungen und anderen Finanzinstrumenten ist mit einem hohen Risiko verbunden, und Sie können einen Teil Ihres Kapitals verlieren. Frühere Ergebnisse, auch von automatisierten oder KI-basierten Strategien, sind keine Garantie für künftige Ergebnisse. Handeln Sie nur mit Geld, dessen Verlust Sie verkraften können.",
    "footRiskLink": "Den vollständigen Risikohinweis lesen.",
    "footInfo": "Der Inhalt dieser Website dient nur der allgemeinen Information. Er ist keine Empfehlung und kein Angebot zum Kauf oder Verkauf eines Vermögenswerts. Er berücksichtigt nicht Ihre persönlichen Ziele, Ihre finanzielle Lage oder Ihre Bedürfnisse. Prüfen Sie vor dem Handel, ob die angebotenen Produkte zu Ihren Zielen und Ihrer Risikobereitschaft passen, und holen Sie bei Bedarf unabhängigen Rat ein.",
    "footOperator": "CapiTrade wird von CapiTrade betrieben, eingetragen in Südafrika unter der Nummer 2021/630672/05. Sitz: First Floor Kgabo Mashego, Eremomela Avenue, 1749, Südafrika. CapiTrade stellt nur Softwarewerkzeuge bereit. Es erteilt keine Anlageberatung und verwahrt keine Kundengelder. Diese Website richtet sich nicht an Personen in einem Land, in dem ihre Nutzung gegen örtliches Recht oder örtliche Vorschriften verstoßen würde.",
    "footRights": "Alle Rechte vorbehalten.",
    "footTerms": "Nutzungsbedingungen",
    "footPrivacy": "Datenschutz",
    "footCookies": "Cookie-Richtlinie",
    "footAml": "AML-Richtlinie",
    "footRiskName": "Risikohinweis",
    "footHours": "Montag bis Freitag, 9:00 bis 18:00",
    "footPolicies": "Richtlinien",
    "docTitle": "CapiTrade — KI-Handel",
    "homeWelcome1": "Öffnen Sie die Welt des",
    "homeWelcome2": "Handels mit",
    "homeWelcome3": "KI.",
    "homeH1": "Vollautomatische Handels-",
    "homeH1em": "plattform.",
    "homeLede": "KI-Handelsagenten mit Tempo, Sicherheit und Zuverlässigkeit.",
    "homeTrade": "Jetzt handeln",
    "homeDeposit": "Erste Einzahlung",
    "homeLicensed": "® Lizenziert und reguliert",
    "homeAltScreen": "Ein dunkler KI-Handelsbildschirm mit einem goldenen Chart auf dem Monitor.",
    "homeAltTrader": "Eine Händlerin lächelt über einen Kurs auf ihrem Telefon.",
    "homeEdge": "Der Kryptomarkt schläft nie, und Ihr Vorteil auch nicht.",
    "homeP1": "Bitcoin und der Rest des Marktes bewegen sich gerade. Jede Minute entsteht neuer Schwung, neue Führende treten hervor, und neue Chancen erscheinen und verschwinden. Unser KI-Handelsbot durchsucht die Kryptomärkte rund um die Uhr, liest Kurs, Volumen und Schwung über Dutzende Werte und nennt die stärksten Kandidaten, damit Sie ihnen nicht hinterherlaufen müssen.",
    "homeP2": "Sie behalten die Kontrolle. Der Bot beobachtet, sortiert und signalisiert. Sie entscheiden und senden den Auftrag. Er handelt nie in Ihrem Namen.",
    "homeWhy": "Warum Händler ihn wählen",
    "homeSpeed": "Tempo",
    "homeSpeedBody": "Signale aktualisieren sich in Echtzeit, Sie sehen die Bewegung also, solange sie noch zählt.",
    "homeSecurity": "Sicherheit",
    "homeSecurityBody": "Ihre Entscheidungen, Ihr Konto, Ihre Mittel. Der Bot hält nie die Schlüssel.",
    "homeReliable": "Zuverlässigkeit",
    "homeReliableBody": "Keine Müdigkeit, keine Ablenkung, kein verpasstes Signal. Er arbeitet den Markt, während Sie Ihr Leben leben.",
    "homeRegister": "Der Markt wird für niemanden langsamer. Registrieren Sie sich heute und stellen Sie einen KI-Analysten an Ihre Seite, solange die Chance noch da ist.",
    "homePlaying": "Wiedergabe",
    "homeFilm": "KI-Film · 00:18",
    "homeQuiet": "ein ruhigerer Handel",
    "homeMorning": "Morgenmarkt",
    "homeLive": "Live",
    "homeOffline": "Der Markt ist offline. Starten Sie die API auf Port 8080.",
    "homeOpening": "Markt wird geöffnet…",
    "homeTradeNvda": "NVIDIA handeln",
    "homeDepKicker": "Lassen Sie Ihre erste Krypto-Einzahlung zählen",
    "homeDepH": "Lassen Sie Ihre erste Krypto-Einzahlung",
    "homeDepEm": "zählen.",
    "homeDepP": "Zahlen Sie zum ersten Mal Krypto auf Ihr Konto ein und erhalten Sie einen Willkommensbonus von bis zu 50 % auf Ihre erste Einzahlung. Danach lässt unser KI-Handelsbot den Markt für Sie arbeiten.",
    "homeHow": "So funktioniert es",
    "homeLi1": "Registrieren",
    "homeLi1b": "und öffnen Sie Ihr Konto in wenigen Minuten.",
    "homeLi2": "Krypto einzahlen",
    "homeLi2b": "(BTC, ETH, USDT und mehr) zum ersten Mal.",
    "homeLi3": "Bonus erhalten",
    "homeLi3b": "und Zugang zu Ihrem eigenen KI-Handelsbot.",
    "homeLi4": "Lassen Sie den Bot Ihr Konto führen",
    "homeLi4b": ", den Markt rund um die Uhr lesen und auf Chancen reagieren, damit Sie nicht jede Bewegung beobachten müssen.",
    "homeFine": "Angebot nur für neue Nutzer. Mindesteinzahlung 250 $. Der Bonus hängt von Handelsvolumen ab. Der Kryptohandel birgt ein hohes Verlustrisiko. Unser KI-Handelsbot und die Portfoliowerkzeuge nutzen Risikotechniken wie Positionsgröße und Stop-Regeln, damit Sie in volatilen Märkten diszipliniert bleiben.",
    "homeSupport": "Weltweiter Support",
    "homeGlobal": "Globaler Service",
    "homeAssist": "Hilfe rund um die Uhr",
    "homeAccess": "Weltweiter Marktzugang",
    "homeMulti": "Mehrsprachiger Support",
    "homeLiveRead": "Live-Lesung",
    "homeFocusA": "Bleiben Sie bei dem Namen, den Sie erklären können.",
    "homeFocusB": "führt den Live-Markt mit",
    "homePaceA": "Märkte stehen höher. Sie brauchen nicht alle. Wählen Sie einen und lassen Sie den Rest im Markt.",
    "homePaceOf": "von",
    "homeNerveA": "ist der schwere Druck bei",
    "homeNerveB": "Bemessen Sie den Handel, bevor Sie dem Gefühl nachlaufen.",
    "homeAnother": "Eine weitere Lesung",
    "homeWait": "Die KI wartet auf den ersten Druck. Starten Sie die API, dann folgt die Lesung dem Markt.",
    "homeAsk": "Die KI fragen",
    "homeReadPrices": "Lesung der Live-Kurse.",
    "homeM1": "Registrieren Sie sich, solange der Markt noch geboten ist.",
    "homeM2": "Lassen Sie die KI den Führenden nennen.",
    "homeM3": "Die erste Einzahlung ist Übungsgeld. Dann senden Sie den Auftrag.",
    "homeClients": "Kunden",
    "homeReviews": "Was sie nach der ersten Sitzung sagen.",
    "homeStars": "5 Sterne",
    "homeR1t": "Krypto",
    "homeR1": "Ich habe eingezahlt, meinen Bonus bekommen und meinen Bot noch am selben Tag laufen gehabt. Die Einrichtung dauerte Minuten und war leicht zu folgen.",
    "homeR2t": "Aktien",
    "homeR2": "Früher starrte ich den ganzen Tag auf Charts. Jetzt beobachtet der Bot den Markt rund um die Uhr, und ich schaue nach, wenn es mir passt.",
    "homeR3t": "Gold und Bitcoin",
    "homeR3": "Was mir gefällt, ist die Disziplin. Der Bot hält seine Risikoregeln ein, auch wenn ich in Panik geraten wäre.",
    "homeMarkets": "Märkte",
    "homeShort": "Eine kurze Liste, mit Absicht.",
    "homeAll": "Alle Märkte",
    "homeThMarket": "Markt",
    "homeThSession": "Sitzung",
    "homeThLast": "Letzter",
    "homeThChange": "Änderung",
    "homeEmpty": "Warten auf den ersten Druck.",
    "homeFourK": "In vier Schritten starten",
    "homeFourH": "Von der Anmeldung zu Ihrem ersten KI-gestützten Handel in Minuten.",
    "homeS1": "Konto eröffnen",
    "homeS1b": "Erstellen Sie Ihr Konto. Geben Sie Name, E-Mail und ein Passwort ein. Die Prüfung dauert nur wenige Minuten.",
    "homeS2": "Einen Markt wählen",
    "homeS2b": "Leisten Sie Ihre erste Einzahlung. Zahlen Sie BTC, ETH, USDT oder andere unterstützte Krypto ein (mindestens 250 $) und holen Sie Ihren Willkommensbonus von bis zu 50 %.",
    "homeS3": "Einen Marktauftrag senden",
    "homeS3b": "Aktivieren Sie Ihren KI-Handelsbot. Wählen Sie Märkte und Risikoeinstellungen, und Ihr Bot beginnt, den Markt rund um die Uhr zu lesen.",
    "homeS4": "Das Konto prüfen",
    "homeS4b": "Verfolgen Sie alles live. Guthaben, Eigenkapital und Gewinn und Verlust aktualisieren sich in Echtzeit. Passen Sie Einstellungen an oder heben Sie ab, wann Sie wollen, vorbehaltlich der Bonusbedingungen.",
    "homeNow": "Jetzt registrieren",
    "homePartners": "Partnerschaften",
    "homeCloseH": "Der stärkere Druck wartet nicht auf",
    "homeCloseEm": "ein leeres Konto.",
    "homeCloseP": "Öffnen Sie heute Ihr Konto, leisten Sie Ihre erste Krypto-Einzahlung von 250 $ oder mehr und erhalten Sie einen Willkommensbonus von bis zu 50 %. Ihr KI-Handelsbot beginnt sofort.",
    "mktKicker": "Markt",
    "mktTitle": "Märkte",
    "mktLede": "Fünfzehn Namen. Suchen, filtern und ein Ticket öffnen.",
    "mktSearch": "Märkte suchen",
    "mktPh": "Symbol oder Name",
    "mktClass": "Anlageklasse",
    "mktMarket": "Markt",
    "mktClassCol": "Klasse",
    "mktTrend": "Trend",
    "mktLast": "Letzter",
    "mktChange": "Änderung",
    "mktVolume": "Volumen",
    "mktOffline": "Die KI ist offline. Starten Sie die API und laden Sie neu.",
    "mktOpening": "Markt wird geöffnet…",
    "mktNone": "Nichts passt zu dieser Suche.",
    "classALL": "Alle",
    "classEQUITY": "Aktien",
    "classINDEX": "Indizes",
    "classCRYPTO": "Krypto",
    "classFX": "Devisen",
    "classCOMMODITY": "Metalle",
    "oneEQUITY": "Aktie",
    "oneINDEX": "Index",
    "oneCRYPTO": "Krypto",
    "oneFX": "Devisen",
    "oneCOMMODITY": "Metall",
    "accTitle": "Konten",
    "accPort": "Ihr Portfolio",
    "accOpen": "Konto eröffnen",
    "accRange": "Von 250 $ bis 100.000 $.",
    "accFrom": "Ab",
    "accClassic": "Classic-Konto",
    "accClassicLine": "Einfacher Zugang. Ein erster Blick auf den Markt, mit Hilfe, wenn Sie fragen.",
    "accSilver": "Silver-Konto",
    "accSilverLine": "Breitere Marktabdeckung, ein Handelsbot, Support rund um die Uhr und 1 Kontomanager auf Anfrage.",
    "accGold": "Gold-Konto",
    "accGoldLine": "Noch breitere Marktabdeckung, mehr Handelsbots, Support rund um die Uhr und 2 Kontomanager auf Anfrage.",
    "accPlat": "Platinum-Konto",
    "accPlatLine": "Tiefe Marktabdeckung, ein stärkeres Set an Handelsbots, vorrangiger Support rund um die Uhr und 3 Kontomanager.",
    "accVip": "VIP-Konto",
    "accVipLine": "Voller Zugang zu einem Finanzberater und 1–5 Kontomanagern, mit jedem Handelsbot und der weitesten Marktabdeckung.",
    "inKicker": "Ihr Konto",
    "inH": "Der Markt wartet nicht.",
    "inP": "Zurück zu Krypto, Aktien und Gold. Tempo, Sicherheit und eine Lesung, die an blieb.",
    "inSpeed": "Tempo",
    "inSpeedB": "Sehen Sie die Bewegung, solange sie noch zählt.",
    "inSec": "Sicherheit",
    "inSecB": "Ihr Konto. Ihre Entscheidungen.",
    "inRel": "Zuverlässigkeit",
    "inRelB": "Die KI macht keinen Feierabend.",
    "inTitle": "Anmelden",
    "inEmail": "E-Mail",
    "inEmailErr": "Geben Sie die E-Mail Ihres Kontos ein.",
    "inPass": "Passwort",
    "inPassErr": "Geben Sie Ihr Passwort ein.",
    "inBusy": "Anmeldung…",
    "inNew": "Neu hier?",
    "inCreate": "Konto erstellen",
    "inFail": "Anmeldung nicht möglich.",
    "upKicker": "Konto eröffnen",
    "upH": "Registrieren Sie sich, solange der Markt offen ist.",
    "upP": "Eine KI für Krypto, Aktien und Gold. Tempo, Sicherheit und eine Lesung, die an bleibt.",
    "upTitle": "Registrieren",
    "upH2": "Erstellen Sie Ihr Konto",
    "upName": "Vollständiger Name",
    "upNameErr": "Sagen Sie uns, wie wir Sie nennen sollen.",
    "upEmailErr": "Geben Sie eine gültige E-Mail ein.",
    "upPhone": "Telefon",
    "upCode": "Ländervorwahl",
    "upCodeShort": "Code",
    "upCodePh": "Land oder Vorwahl",
    "upNoCountry": "Kein Land passt dazu.",
    "upNumber": "Nummer",
    "upReal": "Geben Sie eine echte",
    "upReal2": "Nummer ein.",
    "upChooseCode": "Wählen Sie die Vorwahl und dann die Nummer.",
    "upCountry": "Land",
    "upSelect": "Land wählen",
    "upCountryErr": "Wählen Sie Ihr Land.",
    "upPassErr": "Mindestens 8 Zeichen.",
    "upConfirm": "Passwort bestätigen",
    "upMismatch": "Die Passwörter stimmen nicht überein.",
    "upBusy": "Wird erstellt…",
    "upCreate": "Konto erstellen",
    "detKicker": "Persönliche Angaben",
    "detH": "Wir möchten Sie besser kennenlernen",
    "detP": "Ein paar Angaben, danach können Sie die Einzahlung öffnen.",
    "detAddress": "Adresse",
    "detCity": "Stadt",
    "detZip": "Postleitzahl",
    "detResidence": "Wohnsitzland",
    "detNation": "Staatsangehörigkeit",
    "detBirth": "Geburtsdatum",
    "detBirthHint": "TT.MM.JJJJ",
    "detBirthErr": "Geben Sie ein echtes Datum als TT.MM.JJJJ ein.",
    "detEmpty": "Füllen Sie jedes Feld aus.",
    "detProceed": "Weiter",
    "detBusy": "Speichern…",
    "upAlready": "Schon registriert?",
    "upFail": "Das Konto konnte nicht geöffnet werden.",
    "trMissing": "Dieser Markt ist nicht auf der KI.",
    "trMissingP": "CapiTrade hält die Liste kurz. Wählen Sie einen anderen Namen vom Markt.",
    "trBack": "Zurück zu den Märkten",
    "trOpen": "Eröffnung",
    "trHigh": "Hoch",
    "trLow": "Tief",
    "trVolume": "Volumen",
    "trSession": "Sitzung",
    "trCandles": "Kerzen",
    "trSide": "Auftragsseite",
    "trBuy": "Kaufen",
    "trSell": "Verkaufen",
    "trQty": "Menge",
    "trFill": "Gesch. Ausführung",
    "trNotional": "Nominal",
    "trCash": "Bargeld",
    "trSending": "Wird gesendet…",
    "trWatchOff": "Von der Liste nehmen",
    "trWatchOn": "Zur Liste hinzufügen",
    "trSign": "Zum Handeln anmelden",
    "trNew": "Neu bei der KI?",
    "trOpenAcc": "Konto öffnen",
    "trFine": "Marktauftrag. Wird sofort am Touch ausgeführt, zuzüglich 0,02 % Spread.",
    "trOpening": "Markt wird geöffnet…",
    "trWatchFail": "Die Liste konnte nicht aktualisiert werden.",
    "trOrderFail": "Der Auftrag wurde nicht ausgeführt.",
    "trQtyZero": "Geben Sie eine Menge größer als null ein.",
    "trFilled": "Ausgeführt {side} {qty} {symbol} zu {price}.",
    "trTicket": "Ticket",
    "pfKicker": "Profil",
    "pfP": "Die auf diesem Konto gespeicherten Angaben.",
    "pfDetails": "Profildaten",
    "pfName": "Name",
    "pfEmail": "E-Mail",
    "pfPhone": "Telefon",
    "pfCountry": "Land",
    "pfCash": "Bargeld",
    "pfMissing": "Nicht hinterlegt",
    "pfBack": "Zurück zur KI",
    "poDeposit": "Einzahlung",
    "poMarkets": "Märkte",
    "poBot": "KI-Bot",
    "poIq": "InvestIQ",
    "poGet": "Bot holen",
    "poHelp": "Hilfe",
    "poProfile": "Profil",
    "poEquity": "Eigenkapital",
    "poPnl": "G&V",
    "poWatch": "Beobachtungsliste",
    "poMovers": "Stärkste Beweger",
    "poSell": "Verkaufen",
    "poBuy": "Kaufen",
    "poEmpty": "Die Beobachtungsliste ist leer.",
    "poChart": "Chart wird geöffnet…",
    "poSymbol": "Symbol",
    "poDay": "Tag",
    "poLast": "letzter",
    "poPositions": "Offene Positionen",
    "poFills": "Letzte Ausführungen",
    "poNoPos": "Sie haben keine offenen Positionen.",
    "poNoPosB": "Kaufen Sie aus der Liste, dann erscheint die Position hier.",
    "poQty": "Menge",
    "poAvg": "Schnitt",
    "poNoFills": "Noch keine Ausführungen.",
    "poNoFillsB": "Ein Marktauftrag erscheint hier, sobald er ausgeführt ist.",
    "poSide": "Seite",
    "poPrice": "Preis",
    "poTime": "Zeit",
    "poOpeningAcc": "Konto wird geöffnet…",
    "poLoadFail": "Das Konto konnte nicht geladen werden.",
    "poPay": "Krypto-Zahlung",
    "poConfirmed": "Sobald Ihre Einzahlung bei uns bestätigt ist, prüfen wir die Zahlung und schreiben sie Ihrem Guthaben gut. Danach erhalten Sie Ihren Bonus und den Zugang zu den Funktionen Ihres Kontos.",
    "poChoose": "Wählen Sie Ihren Kontotyp",
    "poAccounts": "Konten",
    "poMin": "Mindesteinzahlung",
    "poNext": "Weiter",
    "poGreat": "Gute Wahl",
    "poPeople": "Personen haben",
    "poStarted": "gewählt und mit dem Handel begonnen.",
    "poNetwork": "Wählen Sie Ihr Netzwerk",
    "poNetworks": "Netzwerke",
    "poBack": "Zurück",
    "poCopied": "Kopiert",
    "poCopy": "Adresse kopieren",
    "poSendOnly": "Senden Sie nur",
    "poOn": "im",
    "poNetworkWord": "Netzwerk.",
    "poAfter": "Nachdem Sie gesendet haben, sagen Sie es der KI auf Telegram.",
    "poLastPrice": "Letzter Preis",
    "poStats": "Statistik",
    "poAnalysis": "Analyse",
    "poIndicators": "Indikatoren",
    "poTape": "Vom Band gelesen.",
    "poBotAlt": "Ein KI-Handelsbot vor Marktbildschirmen.",
    "poBotTitle": "KI-Handelsbot",
    "poBotP": "Der Bot bleibt für Sie am Band. Er folgt dem Trend, dem RSI und den gleitenden Durchschnitten und arbeitet das Konto, während Sie nicht vor dem Bildschirm sind.",
    "poBotAccess": "Zahlen Sie auf Ihr Konto ein, um den Bot zu nutzen.",
    "poHelpTitle": "Mit der KI sprechen",
    "poHelpP": "Wählen Sie eine Frage. Der Chat antwortet und bietet dann den nächsten Schritt. Er sagt Ihnen nicht, was Sie kaufen sollen.",
    "poExplain": "Die KI erklären",
    "poReadM": "Einen Markt lesen",
    "poOpenMine": "Mein Konto öffnen",
    "askTitle": "KI-Assistent",
    "askSub": "Eine Frage nach der anderen. Keine Anlageberatung.",
    "askStart": "Womit sollen wir anfangen? Ich antworte Schritt für Schritt und sage Ihnen nicht, was Sie kaufen sollen.",
    "askPh": "Oder schreiben Sie Ihre eigene Frage",
    "askSend": "Senden",
    "askReplying": "Die KI antwortet.",
    "askOffline": "Ich brauche die API auf Port 8080, bevor ich antworten kann. Starten Sie sie und fragen Sie erneut.",
    "lgHome": "Startseite",
    "lgPdf": "Datenschutz öffnen (PDF)",
    "lgTermsT": "Nutzungsbedingungen",
    "lgTerms1": "Diese Bedingungen beschreiben, wie der CapiTrade-Übungstisch genutzt werden darf. Die vollständigen Betriebsbedingungen werden hier veröffentlicht, sobald Firmenname, Land und Registernummer feststehen.",
    "lgTerms2": "Der Inhalt dieser Website dient nur der allgemeinen Information. Er ist keine Anlageberatung, keine Empfehlung und kein Angebot zum Kauf oder Verkauf eines Vermögenswerts. Er berücksichtigt nicht Ihre persönlichen Ziele, Ihre finanzielle Lage oder Ihre Bedürfnisse.",
    "lgTerms3": "CapiTrade wird von CapiTrade betrieben, eingetragen in Südafrika unter der Nummer 2021/630672/05.",
    "lgPrivT": "Datenschutz",
    "lgPriv1": "Der Datenschutz ist das unten verlinkte PDF. Es beschreibt, was CapiTrade erhebt, warum, und welche Rechte Sie nach POPIA haben.",
    "lgCookT": "Cookie-Richtlinie",
    "lgCook1": "Die Website speichert ein Anmeldetoken im Browser, damit das Konto offen bleibt. Sie zeigt kein Marketing-Banner und setzt keine Werbe-Cookies. Sie können das Token durch Abmelden oder durch Löschen der Daten dieser Website im Browser entfernen.",
    "lgAmlT": "AML-Richtlinie",
    "lgAml1": "Eine bestätigte Einzahlung wird geprüft, bevor sie einem Guthaben gutgeschrieben wird. Die vollständige Richtlinie gegen Geldwäsche wird hier veröffentlicht, sobald Firmenname, Land und Registernummer feststehen.",
    "lgRiskT": "Risikohinweis",
    "lgRisk1": "Der Handel mit Kryptowährungen und anderen Finanzinstrumenten ist mit einem hohen Risiko verbunden, und Sie können einen Teil Ihres Kapitals verlieren. Frühere Ergebnisse, auch von automatisierten oder KI-basierten Strategien, sind keine Garantie für künftige Ergebnisse. Handeln Sie nur mit Geld, dessen Verlust Sie verkraften können.",
    "lgRisk2": "Der Inhalt dieser Website dient nur der allgemeinen Information. Er ist keine Empfehlung und kein Angebot zum Kauf oder Verkauf eines Vermögenswerts. Er berücksichtigt nicht Ihre persönlichen Ziele, Ihre finanzielle Lage oder Ihre Bedürfnisse. Prüfen Sie vor dem Handel, ob die angebotenen Produkte zu Ihren Zielen und Ihrer Risikobereitschaft passen, und holen Sie bei Bedarf unabhängigen Rat ein.",
    "iqNoCandles": "Das Band hat noch keine 14 Kerzen, daher können RSI, MACD und die Durchschnitte nicht berechnet werden.",
    "iqRsiLine": "Der RSI (14) von {symbol} steht bei {rsi}{shift}. {note}",
    "iqShiftUp": ", höher als {prior} vor drei Kerzen",
    "iqShiftDown": ", tiefer als {prior} vor drei Kerzen",
    "iqShiftFlat": ", fast unverändert gegenüber {prior} vor drei Kerzen",
    "iqRsiHigh": "Ein Wert über 70 bedeutet, dass die letzten 14 Kerzen viel schneller gestiegen als gefallen sind.",
    "iqRsiLow": "Ein Wert unter 30 bedeutet, dass die letzten 14 Kerzen viel schneller gefallen als gestiegen sind.",
    "iqRsiMid": "Das ist die Mitte der Skala von 0 bis 100, jüngste Gewinne und Verluste liegen also nah beieinander.",
    "iqMacdLine": "Der MACD steht bei {line}, {side} seinem Signal bei {signal}, und {hist}.",
    "iqAbove": "über",
    "iqBelow": "unter",
    "iqHistPosWide": "das Histogramm ist positiv und wird breiter",
    "iqHistPosNarrow": "das Histogramm ist positiv und wird enger",
    "iqHistNegWide": "das Histogramm ist negativ und wird breiter",
    "iqHistNegNarrow": "das Histogramm ist negativ und wird enger",
    "iqHistPos": "das Histogramm ist positiv",
    "iqHistNeg": "das Histogramm ist negativ",
    "iqHistFlat": "das Histogramm ist flach",
    "iqPrice20": "Der Kurs liegt {side} dem 20-Perioden-Durchschnitt bei {price}.",
    "iqPrice2050": "Der Kurs liegt {a} dem 20-Perioden-Durchschnitt bei {p20} und {b} dem 50-Perioden-Durchschnitt bei {p50}.",
    "iqBandUp": "Der Kurs liegt außerhalb des oberen Bollinger-Bands bei {price}.",
    "iqBandDown": "Der Kurs liegt außerhalb des unteren Bollinger-Bands bei {price}.",
    "iqBandIn": "Der Kurs liegt innerhalb der Bollinger-Bänder, von {low} bis {high}.",
    "iqStochTop": "Stochastic %K steht bei {value}, nahe dem oberen Ende seiner 14-Kerzen-Spanne.",
    "iqStochBot": "Stochastic %K steht bei {value}, nahe dem unteren Ende seiner 14-Kerzen-Spanne.",
    "iqStoch": "Stochastic %K steht bei {value}.",
    "iqAtrLine": "Die durchschnittliche wahre Spanne (14) beträgt {range}.",
    "iqSession": "In der Sitzung liegt der Kurs {above} über dem Tief und {under} unter dem Hoch, {pct} % durch die Spanne.",
    "iqSelect": "Wählen Sie ein Symbol, um die Sitzung zu lesen.",
    "iqPlace": "Der letzte Druck liegt bei {pct} % des Wegs vom Sitzungstief {low} zum Sitzungshoch {high}.",
    "iqStretched": "Gedehnt",
    "iqWashed": "Ausgewaschen",
    "iqFirm": "Fest",
    "iqSoft": "Weich",
    "iqNeutral": "Neutral",
    "iqRsiName": "RSI (14)",
    "iqMacdName": "MACD (12, 26)",
    "iqSignalName": "Signal (9)",
    "iqHistName": "Histogramm",
    "iqSma20Name": "SMA 20",
    "iqSma50Name": "SMA 50",
    "iqBollUpName": "Bollinger oben",
    "iqBollLoName": "Bollinger unten",
    "iqStochName": "Stochastic %K",
    "iqAtrName": "ATR (14)",
    "iqMacdNote": "Schneller Durchschnitt minus langsamer Durchschnitt",
    "iqSignalNote": "9-Perioden-Durchschnitt des MACD",
    "iqBollUpNote": "20-Perioden-Durchschnitt plus 2 Abweichungen",
    "iqBollLoNote": "20-Perioden-Durchschnitt minus 2 Abweichungen",
    "iqAtrNote": "Durchschnittliche wahre Spanne der letzten 14 Kerzen",
    "iqNeeds15": "Braucht 15 Schlüsse",
    "iqNeeds35": "Braucht 35 Schlüsse",
    "iqNeeds14": "Braucht 14 Kerzen",
    "iqNeedsMore": "Braucht mehr Kerzen für {label}",
    "iqAboveLabel": "Der Kurs liegt über {label}",
    "iqBelowLabel": "Der Kurs liegt unter {label}",
    "iqRsiStretchNote": "Gedehnt, über 70",
    "iqRsiWashNote": "Ausgewaschen, unter 30",
    "iqRsiMidNote": "Mitte der Skala",
    "iqStochTopNote": "Nahe dem oberen Ende der Spanne",
    "iqStochBotNote": "Nahe dem unteren Ende der Spanne",
    "iqStochMidNote": "Nahe am Hoch und Tief der 14 Kerzen",
    "iqAvg20": "dem 20-Perioden-Durchschnitt",
    "iqAvg50": "dem 50-Perioden-Durchschnitt",
    "trustOpening": "Trust Wallet wird auf dieser Seite geöffnet…",
    "trustConnected": "Trust Wallet ist offen. Ihre Adresse auf dieser Seite:",
    "trustMissing": "Trust Wallet ist in diesem Browser nicht installiert. Fügen Sie die Trust-Wallet-Erweiterung hinzu und öffnen Sie sie hier erneut. Sie bleiben auf dieser Einzahlungsseite.",
    "trustClosed": "Trust Wallet wurde geschlossen.",
    "trustRetry": "Trust Wallet öffnen",
    "trustDownload": "Trust Wallet holen"
  },
};

